document.addEventListener('DOMContentLoaded', function() {
  //console.log('🚀 Custom Tracking: Script Initialized');



/**
 * 17. View Cart Ecommerce Event
 * Added: index, item_list_id, and item_list_name to the items array.
 */
const trackViewCartPage = async () => {
  if (window.location.pathname !== '/cart') return;

  try {
    const response = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await response.json();

    if (cart && cart.item_count > 0) {
      // 1. Clear previous ecommerce data
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });

      // 2. Prepare items array
      const ga4Items = cart.items.map((item, idx) => {
        const itemData = {
          item_id: item.product_id.toString().substring(0, 100),
          item_name: (item.product_title || '').substring(0, 100),
          item_brand: (item.vendor || 'Candela').substring(0, 100),
          item_category: (item.product_type || '').substring(0, 100),
          price: item.final_price / 100,
          quantity: item.quantity,
          index: idx, // 1-based index
          item_list_id: 'cart', // Static identifier for the cart list
          item_list_name: 'Cart'
        };

        // Variant logic: Omit if Default Title
        if (item.variant_title && item.variant_title !== 'Default Title') {
          itemData.item_variant = item.variant_title.substring(0, 100);
        }

        return itemData;
      });

      // 3. Construct Payload
      const finalPayload = {
        event: 'view_cart',
        ecommerce: {
          currency: cart.currency,
          value: cart.total_price / 100,
          items: ga4Items
        }
      };

      // 4. DataLayer Push
      window.dataLayer.push(finalPayload);

      // 5. Console Logging for QA
    //   console.group('%c🛒 GA4 ECOMMERCE: view_cart', 'background: #27ae60; color: #fff; padding: 2px 5px; font-weight: bold;');
    //   console.log('Action: dataLayer.push()');
    //   console.log('Payload:', finalPayload);
    //   console.table(ga4Items); 
    //   console.groupEnd();
    }
  } catch (err) {
    console.error('❌ GA4 view_cart Error:', err);
  }
};

// Initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', trackViewCartPage);
} else {
  trackViewCartPage();
}

/**
 * 19. Select Item Tracking (Main Cart Page)
 * Added: quantity from cart.js response.
 */
const initSelectItemCart = () => {
  // Only execute on the main cart page
  if (window.location.pathname !== '/cart') return;

  document.addEventListener('click', async (event) => {
    // 1. Identify if the click is on a product link
    const link = event.target.closest('cart-item a[href*="/products/"]');
    if (!link) return;

    try {
      const cartItemElement = link.closest('cart-item');
      if (!cartItemElement) return;

      // 2. Fetch current cart state
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await response.json();

      // 3. Match using 'key' attribute
      const itemKey = cartItemElement.getAttribute('key');
      const clickedItem = cart.items.find(item => item.key === itemKey);

      if (clickedItem) {
        const index = cart.items.indexOf(clickedItem);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });

        // 4. Construct Item Data
        const itemData = {
          item_id: clickedItem.product_id.toString().substring(0, 100),
          item_name: (clickedItem.product_title || '').substring(0, 100),
          item_brand: (clickedItem.vendor || 'Candela').substring(0, 100),
          item_category: (clickedItem.product_type || '').substring(0, 100),
          price: clickedItem.final_price / 100,
          quantity: clickedItem.quantity, // Added: Dynamic quantity from cart
          index: index,
          item_list_id: 'cart',
          item_list_name: 'Cart'
        };

        if (clickedItem.variant_title && clickedItem.variant_title !== 'Default Title') {
          itemData.item_variant = clickedItem.variant_title.substring(0, 100);
        }

        const finalPayload = {
          event: 'select_item',
          ecommerce: {
            currency: cart.currency,
            item_list_id: 'cart',
            item_list_name: 'Cart',
            items: [itemData]
          }
        };

        // 5. Push to DataLayer
        window.dataLayer.push(finalPayload);

        // 6. Verification
        // console.group('%c🖱️ GA4 ECOMMERCE: select_item (Cart Page)', 'background: #3498db; color: #fff; padding: 2px 5px; font-weight: bold;');
        // console.log('Action: dataLayer.push()');
        // console.log('Payload:', finalPayload);
        // console.table([itemData]); 
        // console.groupEnd();
      }
    } catch (err) {
      console.error('❌ GA4 select_item Error:', err);
    }
  });
};




/**
 * 20. Add to Cart Tracking - Quantity Increments
 * Added: index, item_list_id, and item_list_name for full schema compliance.
 */
const initAddToCartQuantity = () => {
  const qtyCache = new Map();

  // 1. Handle Plus Button Clicks
  document.addEventListener('click', async (event) => {
    const plusButton = event.target.closest('button[plus]');
    if (!plusButton) return;

    const cartItemElement = plusButton.closest('cart-item');
    const itemKey = cartItemElement?.getAttribute('key');
    
    if (itemKey) {
      triggerQuantityAddToCart(itemKey, 1);
    }
  });

  // 2. Handle Manual Input Changes
  document.addEventListener('focusin', (event) => {
    if (event.target.matches('quantity-input input')) {
      qtyCache.set(event.target.id, parseInt(event.target.value) || 0);
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('quantity-input input')) {
      const input = event.target;
      const oldQty = qtyCache.get(input.id) || 0;
      const newQty = parseInt(input.value) || 0;
      const delta = newQty - oldQty;

      if (delta > 0) {
        const cartItemElement = input.closest('cart-item');
        const itemKey = cartItemElement?.getAttribute('key');
        if (itemKey) triggerQuantityAddToCart(itemKey, delta);
      }
      qtyCache.set(input.id, newQty);
    }
  });

  async function triggerQuantityAddToCart(itemKey, delta) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await response.json();
      
      // Find the item and its index in the cart
      const itemIndex = cart.items.findIndex(i => i.key === itemKey);
      const item = cart.items[itemIndex];

      if (item) {
        const unitPrice = item.final_price / 100;
        
        // Construct Standardized Item Data
        const itemData = {
          item_id: item.product_id.toString().substring(0, 100),
          item_name: (item.product_title || '').substring(0, 100),
          item_brand: (item.vendor || 'Candela').substring(0, 100),
          item_category: (item.product_type || '').substring(0, 100),
          price: unitPrice,
          quantity: delta, // The amount added, not the total
          index: itemIndex, // Added 1-based index
          item_list_id: 'cart',
          item_list_name: 'Cart'
        };

        if (item.variant_title && item.variant_title !== 'Default Title') {
          itemData.item_variant = item.variant_title.substring(0, 100);
        }

        const addToCartPayload = {
          event: 'add_to_cart',
          ecommerce: {
            currency: cart.currency,
            value: Number((unitPrice * delta).toFixed(2)),
            items: [itemData]
          }
        };

        // 3. DataLayer Clear and Push
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(addToCartPayload);

        // 4. Verification Log
        // console.group('%c➕ GA4 ECOMMERCE: add_to_cart (Qty Update)', 'background: #2ecc71; color: #fff; padding: 2px 5px; font-weight: bold;');
        // console.log('Action: Quantity Increase');
        // console.log('Payload:', addToCartPayload);
        // console.table([itemData]);
        // console.groupEnd();
      }
    } catch (err) {
      console.error('❌ GA4 add_to_cart Error:', err);
    }
  }
};



/**
 * Remove from Cart Tracking
 * Updates: Added index, refined item_variant logic to prevent empty strings.
 */
/**
 * 21. Remove From Cart Tracking
 * Added: 1-based index, item_list_id, and item_list_name.
 * QA
 */
const initRemoveFromCartTracking1 = () => {
  const qtyCache = new Map();

  // 1. Handle Click Events (Trash and Minus Button)
  document.addEventListener('click', async (event) => {
    const removeBtn = event.target.closest('.cart-item__remove');
    const minusBtn = event.target.closest('button[minus]');
    
    if (!removeBtn && !minusBtn) return;

    const cartItemElement = (removeBtn || minusBtn).closest('cart-item');
    const itemKey = cartItemElement?.getAttribute('key');
    if (!itemKey) return;

    if (removeBtn) {
      // If trash is clicked, remove the entire current quantity
      const currentQty = parseInt(cartItemElement.querySelector('quantity-input input')?.value) || 1;
      triggerRemoveFromCart(itemKey, currentQty);
    } else if (minusBtn) {
      // If minus is clicked, remove 1
      triggerRemoveFromCart(itemKey, 1);
    }
  });

  // 2. Handle Manual Input Changes
  document.addEventListener('focusin', (event) => {
    if (event.target.matches('quantity-input input')) {
      qtyCache.set(event.target.id, parseInt(event.target.value) || 0);
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('quantity-input input')) {
      const input = event.target;
      const oldQty = qtyCache.get(input.id) || 0;
      const newQty = parseInt(input.value) || 0;
      const deltaRemoved = oldQty - newQty;

      if (deltaRemoved > 0) {
        const cartItemElement = input.closest('cart-item');
        const itemKey = cartItemElement?.getAttribute('key');
        if (itemKey) triggerRemoveFromCart(itemKey, deltaRemoved);
      }
      qtyCache.set(input.id, newQty);
    }
  });

  /**
   * Core function to fetch item data and push to DataLayer
   */
  async function triggerRemoveFromCart(itemKey, deltaRemoved) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await response.json();
      
      // Find the item and its index
      const itemIndex = cart.items.findIndex(i => i.key === itemKey);
      const item = cart.items[itemIndex];

      if (item) {
        const unitPrice = item.final_price / 100;
        
        // Prepare Item Object
        const itemData = {
          item_id: item.product_id.toString().substring(0, 100),
          item_name: (item.product_title || '').substring(0, 100),
          item_brand: (item.vendor || 'Candela').substring(0, 100),
          item_category: (item.product_type || '').substring(0, 100),
          price: unitPrice,
          quantity: deltaRemoved,
          index: itemIndex, // Enabled 1-based index
          item_list_id: 'cart',
          item_list_name: 'Cart'
        };

        if (item.variant_title && item.variant_title !== 'Default Title' && item.variant_title.trim() !== "") {
          itemData.item_variant = item.variant_title.substring(0, 100);
        }

        const removeFromCartPayload = {
          event: 'remove_from_cart',
          ecommerce: {
            currency: cart.currency,
            value: Number((unitPrice * deltaRemoved).toFixed(2)),
            items: [itemData]
          }
        };

        // 3. DataLayer Reset and Push
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(removeFromCartPayload);

        // 4. Console Logging
        // console.group('%c➖ GA4 ECOMMERCE: remove_from_cart', 'background: #e74c3c; color: #fff; padding: 2px 5px; font-weight: bold;');
        // console.log('Action: dataLayer.push()');
        // console.log('Payload:', removeFromCartPayload);
        // console.table([itemData]);
        // console.groupEnd();
      }
    } catch (err) {
      console.error('❌ GA4 remove_from_cart Error:', err);
    }
  }
};


/**
 * Click CTA Tracking
 * Specifically tracks the "Continue shopping" link on the cart page.
 */
const initCartCtaTrackingCountinue = () => {
  document.addEventListener('click', (event) => {
    // Target the specific "Continue shopping" link by its class
    const continueBtn = event.target.closest('.cart__continue');
    
    if (continueBtn) {
      const ctaPayload = {
        event: 'click_cta',
        element_text: 'Continue shopping',
        element_location: 'cart_page'
      };

      // Push to DataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(ctaPayload);

      // Debug Logging
    //   console.group('%c🔗 GA4 CUSTOM: click_cta', 'background: #3498db; color: #fff; padding: 2px 5px; font-weight: bold;');
    //   console.log('Text:', ctaPayload.element_text);
    //   console.log('Location:', ctaPayload.element_location);
    //   console.log('Full Object:', ctaPayload);
    //   console.groupEnd();
    }
  });
};

/**
 * Click CTA Tracking
 * Specifically tracks the "View cart" link within the cart drawer.
 */
const initViewCartTracking = () => {
  document.addEventListener('click', (event) => {
    // Target the "View cart" link by its unique class
    const viewCartBtn = event.target.closest('.cart__view');
    
    // Ensure the click is happening within the context of the drawer
    const isInDrawer = event.target.closest('#drawer-cart');

    if (viewCartBtn && isInDrawer) {
      const ctaPayload = {
        event: 'click_cta',
        element_text: 'View cart',
        element_location: 'cart_drawer'
      };

      // Push to DataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(ctaPayload);

      // Debugging
    //   console.group('%c🔗 GA4 CUSTOM: click_cta', 'background: #e67e22; color: #fff; padding: 2px 5px; font-weight: bold;');
    //   console.log('Text:', ctaPayload.element_text);
    //   console.log('Location:', ctaPayload.element_location);
    //   console.groupEnd();
    }
  });
};


  // --- Header Contact Us CTA ---
 const initContactCtaClick = () => {
  // Broad selector to ensure we find the links
  const navLinks = document.querySelectorAll('header a, nav a, .header-navs a');
  
  //console.log(`🔍 Contact Tracking: Found ${navLinks.length} links in header/nav`);

  navLinks.forEach(link => {
    const linkText = link.textContent.trim();
    
    if (linkText.toLowerCase().includes('contact us')) {
      //console.log('✅ Contact Tracking: Listener attached to "Contact us"');
      
      link.addEventListener('click', function() {
        // 1. Prepare the push data
        const pushData = {
          event: 'click_cta',
          element_text: 'Contact us', // Standardized text
          element_location: 'header'
        };

        // 2. DataLayer Push
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(pushData);
        
        // 3. Final verification log showing the exact object
        // console.log(
        //   `%c📊 CTA CLICK: Contact us`, 
        //   'background: #16a085; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;',
        //   pushData
        // );
      });
    }
  });
};


  

  /**
 * 22. Cart / Order Now CTA Tracking
 * Captures "Order Now" (Desktop) and the Cart Icon (Mobile).
 */
const initCartCtaTracking = () => {
  // Select both the desktop link and the mobile trigger container
  const cartTriggers = document.querySelectorAll('.secondary-nav__item--cart a, .js-cart-draw-icon a');

  cartTriggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      try {
        // 1. Determine Text: Get text from span (desktop) or hardcode 'Cart' if no text (mobile)
        let elementText = this.querySelector('span')?.innerText.trim() || 'Cart';
        
        // 2. Double-check for desktop 'Order Now' specifically
        if (elementText === '0' || elementText === '') {
           elementText = 'Cart';
        }

        // 3. Console Debugging
        // console.group('🛒 GA4 Event: click_cta (Cart/Order)');
        // console.log('%cText:', 'color: #e67e22; font-weight: bold;', elementText);
        // console.log('%cLocation:', 'color: #e67e22;', 'header');
        // console.groupEnd();

        // 4. DataLayer Push
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'click_cta',
          element_text: elementText,
          element_location: 'header'
        });

        //console.log('%c✅ SUCCESS: click_cta fired!', 'background: #e67e22; color: #fff; padding: 2px 5px;');

      } catch (err) {
        console.error('❌ GA4 click_cta Error:', err);
      }
    });
  });
};


  // --- 4. ROI Calculator Click ---
  const initRoiCalculatorClick = () => {
    // Target the specific class from your HTML
    const roiBtn = document.querySelector('.croi-btn');
    if (roiBtn) {
      //console.log('✅ Custom Tracking: ROI Calculator button identified');
      roiBtn.addEventListener('click', function() {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'click_cta',
          element_text: 'Open ROI Calculator',
          element_location: 'roi_calculator_section'
        });
        //console.log('📊 DataLayer Push: event "click_cta" (ROI Calculator) sent!');
      });
    } else {
      //console.log('⚠️ Custom Tracking: ROI Calculator button NOT found by .croi-btn');
    }
  };


  // --- 5 & 6. Footer Navigation CTAs ---
  const initFooterCtaClicks = () => {
    const footerLinks = document.querySelectorAll('.footer-nav a');
    
    footerLinks.forEach(link => {
      const linkText = link.textContent.trim().toLowerCase();
      
      // Handle "Contact Us" in Footer
      if (linkText === 'contact us') {
        //console.log('✅ Custom Tracking: Footer "Contact Us" identified');
        link.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'click_cta',
            element_text: 'Contact Us',
            element_location: 'footer'
          });
          //console.log('📊 DataLayer Push: event "click_cta" (Footer Contact) sent!');
        });
      }

      // Handle "Schedule Demo" in Footer
      if (linkText === 'schedule demo') {
        //console.log('✅ Custom Tracking: Footer "Schedule Demo" identified');
        link.addEventListener('click', function() {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'click_cta',
            element_text: 'Schedule Demo',
            element_location: 'footer'
          });
          //console.log('📊 DataLayer Push: event "click_cta" (Footer Demo) sent!');
        });
      }
    });
  };


/**
 * Global variables to hold Glace product data captured on page load
 */
// let globalGlacePrice = 0;
// let globalGlaceName = '';
// let globalGlaceType = '';

/**
 * 8. View Item Tracking for Glace template
 * Updated to use data-product-id attribute for consistent item_id.
 */
const initViewItemTracking = () => {
  // 1. Check if we are on the Glace template
  if (!document.body.classList.contains('is-glace-product')) {
    return;
  }
  
  // 2. Prevent double firing
  if (window.viewItemFired) return;
  window.viewItemFired = true;

  try {
    // 3. NEW: Scrape Product ID from the data-product-id attribute
    const productContainer = document.querySelector('product-single[data-product-id]');
    const productIdAttr = productContainer ? productContainer.getAttribute('data-product-id') : '';

    // 4. Scrape and Store Name/Type/Price
    const rawName = document.querySelector('h1.glace-title, .product__title')?.textContent.trim() || 'Unknown Product';
    globalGlaceName = rawName.substring(0, 100);
    
    const typeElement = document.querySelector('.product-form__type-text');
    const rawTypeString = typeElement ? typeElement.textContent : 'PTO';
    globalGlaceType = rawTypeString.replace(/Product Type:|Type:/gi, '').trim().substring(0, 100);
    
    const priceElement = document.querySelector('.glace-current-price, .price .money');
    const priceRaw = priceElement ? priceElement.textContent.trim() : '0';
    globalGlacePrice = parseFloat(priceRaw.replace(/[^0-9.]/g, '')) || 0;

    // 5. Get Variant Info for Variant Name logic
    const shopifyProduct = window.ShopifyAnalytics?.meta?.product || {};
    const urlParams = new URLSearchParams(window.location.search);
    const currentVariantId = urlParams.get('variant');
    const variantObj = shopifyProduct.variants?.find(v => v.id == currentVariantId) || shopifyProduct.variants?.[0];

    // 6. Build the Item Object
    const viewItemObject = {
      item_id: productIdAttr.substring(0, 100), // Updated to use the data-product-id
      item_name: globalGlaceName,
      item_brand: 'Candela',
      item_category: globalGlaceType,
      price: globalGlacePrice,
      quantity: 1
    };

    /**
     * 7. FIXED ITEM_VARIANT: 
     * Omit if "Default Title", empty, or undefined
     */
    const variantTitle = variantObj?.public_title || variantObj?.title;
    if (variantTitle && variantTitle !== 'Default Title' && variantTitle.trim() !== "") {
      viewItemObject.item_variant = variantTitle.substring(0, 100);
    }

    // 8. DataLayer Push
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null }); // Clear previous ecommerce object
    window.dataLayer.push({
      event: 'view_item',
      ecommerce: {
        currency: 'USD',
        value: globalGlacePrice,
        items: [viewItemObject]
      }
    });

    // Success Console
    // console.group('%c👁️ GA4 ECOMMERCE: view_item', 'background: #3498db; color: #fff; padding: 2px 5px; font-weight: bold;');
    // console.log('Using data-product-id:', productIdAttr);
    // console.log('Payload:', { event: 'view_item', ecommerce: { items: [viewItemObject] } });
    // console.groupEnd();

  } catch (err) {
    console.error('❌ GA4 View Item Error:', err);
  }
};


/**
 * 9. Add to Cart Tracking for Glace
 * Updated to use data-product-id for consistency and removed global variable dependencies.
 */
const initAddToCartTracking = () => {
  if (!document.body.classList.contains('is-glace-product')) return;

  const productForm = document.querySelector('form[action="/cart/add"]');
  if (!productForm) return;

  productForm.addEventListener('submit', function() {
    try {
      // 1. Get Product ID from the container attribute
      const productContainer = document.querySelector('product-single[data-product-id]');
      const productIdAttr = productContainer ? productContainer.getAttribute('data-product-id') : '';

      // 2. Get Form Data (Variant ID and Quantity)
      const variantInput = productForm.querySelector('input[name="id"]');
      const currentVariantId = variantInput ? variantInput.value : '';
      
      const quantityInput = productForm.querySelector('input[name="quantity"]');
      const quantity = quantityInput ? parseInt(quantityInput.value) : 1;

      // 3. Scrape current Name, Price, and Type locally
      const nameElement = document.querySelector('h1.glace-title, .product__title');
      const productName = (nameElement?.textContent.trim() || 'Unknown Product').substring(0, 100);

      const typeElement = document.querySelector('.product-form__type-text');
      const productType = (typeElement?.textContent.replace(/Product Type:|Type:/gi, '').trim() || 'PTO').substring(0, 100);

      const priceElement = document.querySelector('.glace-current-price, .price .money');
      const currentPrice = priceElement ? parseFloat(priceElement.textContent.replace(/[^0-9.]/g, '')) : 0;

      // 4. Find Variant Object for the Title
      const shopifyProduct = window.ShopifyAnalytics?.meta?.product || {};
      const variantObj = shopifyProduct.variants?.find(v => v.id == currentVariantId) || shopifyProduct.variants?.[0];

      // 5. Construct Item Object
      const addToCartItem = {
        item_id: productIdAttr.substring(0, 100), // Updated to use data-product-id
        item_name: productName,
        item_brand: 'Candela',
        item_category: productType,
        price: currentPrice,
        quantity: quantity
      };

      // 6. Correct item_variant logic: Omit if "Default Title" or empty
      const variantTitle = variantObj?.public_title || variantObj?.title;
      if (variantTitle && variantTitle !== 'Default Title' && variantTitle.trim() !== "") {
        addToCartItem.item_variant = variantTitle.substring(0, 100);
      }

      // 7. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null }); 
      window.dataLayer.push({
        event: 'add_to_cart',
        ecommerce: {
          currency: 'USD',
          value: Number((currentPrice * quantity).toFixed(2)),
          items: [addToCartItem]
        }
      });

      // 8. Log the Final Push Data
    //   console.group('%c🛒 GA4 ECOMMERCE: add_to_cart', 'background: #f1c40f; color: #000; padding: 2px 5px; font-weight: bold;');
    //   console.log('Using data-product-id:', productIdAttr);
    //   console.log('Final Payload:', { event: 'add_to_cart', ecommerce: { items: [addToCartItem] } });
    //   console.groupEnd();

    } catch (err) {
      console.error('❌ GA4 Add To Cart Error:', err);
    }
  });
};

/**
 * 10. Click CTA Tracking for Request Live Demo
 */
const initClickCtaTracking = () => {
  // 1. Only run on Glace Template
  if (!document.body.classList.contains('is-glace-product')) return;

  // 2. Target the specific demo button class
  const demoBtn = document.querySelector('.glace-demo-btn');
  if (!demoBtn) return;

  demoBtn.addEventListener('click', function() {
    try {
      const elementText = this.textContent.trim();
      const elementLocation = 'product_form';

      // 3. Individual Value Logs
    //   console.group('🖱️ GA4 Custom Event: click_cta');
    //   console.log('%cElement Text:', 'color: #9b59b6; font-weight: bold;', elementText);
    //   console.log('%cElement Location:', 'color: #9b59b6; font-weight: bold;', elementLocation);
    //   console.groupEnd();

      // 4. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'click_cta',
        element_text: elementText,
        element_location: elementLocation
      });

      // 5. Success Console
      //console.log('%c✅ SUCCESS: GA4 "click_cta" event fired successfully!', 'background: #9b59b6; color: #fff; padding: 2px 5px;');

    } catch (err) {
      console.error('❌ GA4 click_cta Error:', err);
    }
  });
};


/**
 * 11. View Item Tracking for Consumable Products
 * Updated: Prioritizes Product ID attribute for consistency and logs final payload.
 */
const initConsumableProductTracking = () => {
  // 1. EXIT if this is a Glace product (to prevent double firing)
  if (document.body.classList.contains('is-glace-product')) {
    //console.log('ℹ️ Consumable Tracking: Glace product detected. Skipping to avoid double event.');
    return;
  }

  // 2. Check if productData exists
  if (!window.productData) return;

  // 3. Prevent double firing
  if (window.consumableViewFired) return;
  window.consumableViewFired = true;

  try {
    const product = window.productData;
    const currency = window.shopCurrency || 'USD';
    
    // Get current variant (usually first for view_item on page load)
    const currentVariant = product.variants[0]; 
    const price = currentVariant.price / 100;

    // 4. Consistent Item ID logic
    // We try data-product-id first (to match Glace), then SKU (PTO-style), then Variant ID
    const productContainer = document.querySelector('[data-product-id]');
    const productIdAttr = productContainer ? productContainer.getAttribute('data-product-id') : null;
    const itemId = String(productIdAttr || currentVariant.sku || currentVariant.id || '').substring(0, 100);
    
    const itemData = {
      item_id: itemId,
      item_name: (product.title || '').substring(0, 100),
      item_brand: (product.vendor || 'Candela').substring(0, 100),
      item_category: (product.type || '').substring(0, 100),
      price: price,
      quantity: 1
    };

    // 5. Clean Variant Logic: Omit if empty or "Default Title"
    const vTitle = currentVariant.title;
    if (vTitle && vTitle !== 'Default Title' && vTitle.trim() !== "") {
      itemData.item_variant = vTitle.substring(0, 100);
    }

    // 6. Prepare Final Payload
    const finalPayload = {
      event: 'view_item',
      ecommerce: {
        currency: currency,
        value: price,
        items: [itemData]
      }
    };

    // 7. DataLayer Push
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null }); // Clear previous
    window.dataLayer.push(finalPayload);

    // 8. Final Detailed Console Log
    // console.group('%c🧪 GA4 ECOMMERCE: view_item (Consumable)', 'background: #3498db; color: #fff; padding: 2px 5px; font-weight: bold;');
    // console.log('Using Item ID:', itemId);
    // console.log('Final DataLayer Push:', finalPayload);
    // console.groupEnd();

  } catch (err) {
    console.error('❌ GA4 Consumable View Error:', err);
  }
};


/**
 * 12. Add to Cart Tracking for Consumable/Non-Glace Products
 * Updated: Prioritizes data-product-id for consistent item_id across all products.
 */
const initConsumableAddToCartTracking = () => {
  // 1. EXIT if this is a Glace product (to prevent double firing)
  if (document.body.classList.contains('is-glace-product')) return;

  // 2. Locate the standard Shopify Add to Cart form
  const productForm = document.querySelector('form[action="/cart/add"]');
  if (!productForm || !window.productData) return;

  productForm.addEventListener('submit', function() {
    try {
      const product = window.productData;
      
      // 3. Get Selected Variant ID from the form
      const variantInput = productForm.querySelector('input[name="id"]');
      const selectedVariantId = variantInput ? variantInput.value : product.variants[0].id;
      
      // Find the variant object to get Price and Title
      const variantObj = product.variants.find(v => v.id == selectedVariantId) || product.variants[0];
      
      // 4. Get Product ID from the container attribute (Consistent with Glace logic)
      const productContainer = document.querySelector('[data-product-id]');
      const productIdAttr = productContainer ? productContainer.getAttribute('data-product-id') : null;
      
      // Fallback logic: Product ID > SKU > Variant ID
      const itemId = String(productIdAttr || variantObj.sku || variantObj.id || '').substring(0, 100);

      // 5. Get Quantity and Price
      const qtyInput = productForm.querySelector('input[name="quantity"]');
      const quantity = qtyInput ? parseInt(qtyInput.value) : 1;
      const price = variantObj.price / 100;
      const currency = window.shopCurrency || 'USD';

      // 6. Build Item Object
      const itemData = {
        item_id: itemId,
        item_name: (product.title || '').substring(0, 100),
        item_brand: (product.vendor || 'Candela').substring(0, 100),
        item_category: (product.type || '').substring(0, 100),
        price: price,
        quantity: quantity
      };

      // Handle Variant Title: Omit if "Default Title" or empty
      const vTitle = variantObj.title;
      if (vTitle && vTitle !== 'Default Title' && vTitle.trim() !== "") {
        itemData.item_variant = vTitle.substring(0, 100);
      }

      // 7. Final Payload
      const finalPayload = {
        event: 'add_to_cart',
        ecommerce: {
          currency: currency,
          value: Number((price * quantity).toFixed(2)),
          items: [itemData]
        }
      };

      // 8. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null }); // Clear previous
      window.dataLayer.push(finalPayload);

      // 9. Detailed Console Log
    //   console.group('%c🛒 GA4 ECOMMERCE: add_to_cart (Consumable)', 'background: #27ae60; color: #fff; padding: 2px 5px; font-weight: bold;');
    //   console.log('Using Item ID:', itemId);
    //   console.log('Final DataLayer Push:', finalPayload);
    //   console.groupEnd();

    } catch (err) {
      console.error('❌ GA4 Consumable Add to Cart Error:', err);
    }
  });
};


/**
 * 12. Collection Click Tracking
 * Fires when a user clicks a collection card, title, or button
 * Updated with 100 character maximum length for event parameter values.
 */
const initCollectionClickTracking = () => {
  // Use event delegation to catch clicks on any collection card
  document.addEventListener('click', function(event) {
    // 1. Find if the clicked element or its parent is the collection link/card
    const collectionCard = event.target.closest('.collection-list__link, .collection-list__item');
    
    if (collectionCard) {
      try {
        // 2. Scrape and Truncate (Max 100 Chars)
        const headingElement = collectionCard.querySelector('.collection-list__content-heading');
        const rawCollectionName = headingElement ? headingElement.textContent.trim() : 'Unknown Collection';
        
        const collectionName = rawCollectionName.substring(0, 100);
        const elementLocation = 'collections_list'.substring(0, 100);

        // 3. Individual Value Logs for Debugging
        // console.group('📂 GA4 Custom Event: collection_click');
        // console.log('%cCollection Name:', 'color: #e74c3c; font-weight: bold;', collectionName);
        // console.log('%cElement Location:', 'color: #e74c3c; font-weight: bold;', elementLocation);
        // console.groupEnd();

        // 4. DataLayer Push
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'collection_click',
          collection_name: collectionName,
          element_location: elementLocation
        });

        // 5. Success Console
        //console.log('%c✅ SUCCESS: GA4 "collection_click" fired for: ' + collectionName, 'background: #e74c3c; color: #fff; padding: 2px 5px;');

      } catch (err) {
        console.error('❌ GA4 collection_click Error:', err);
      }
    }
  });
};

/**
 * 13. Newsletter Signup Tracking (Multi-Page Success)
 * Fires ONLY when Shopify redirects the user back with a success flag.
 */
const initNewsletterSignupTracking = () => {
  // 1. Define the specific pages we want to track
  const targetPages = [
    '/pages/see-it-in-action',
    '/pages/learn-and-go-deeper',
    '/pages/about-us',
    '/blogs/',
    '/pages/here-from-real-spas-success-stories'
  ];

  const currentPath = window.location.pathname;
  
  // 2. Security Check: Are we on a target page?
  const isTargetPage = targetPages.some(page => currentPath.includes(page));
  if (!isTargetPage) return;

  // 3. Success Check: Did the URL contain Shopify's success flag?
  const urlParams = new URLSearchParams(window.location.search);
  const isSuccess = urlParams.get('customer_posted') === 'true';

  if (isSuccess) {
    try {
      // 4. Prevent double firing on page refresh
      const eventKey = `newsletter_fired_${currentPath}`;
      if (sessionStorage.getItem(eventKey)) return;
      sessionStorage.setItem(eventKey, 'true');

      const elementLocation = 'newsletter_section';
      const formId = 'newsletter';

      // 5. Individual Value Logs (Debugging)
    //   console.group('📧 GA4 Custom Event: newsletter_signup (VERIFIED)');
    //   console.log('%cStatus:', 'color: #27ae60; font-weight: bold;', 'Success Parameter Detected');
    //   console.log('%cPage Path:', 'color: #27ae60;', currentPath);
    //   console.log('%cElement Location:', 'color: #27ae60;', elementLocation);
    //   console.log('%cForm ID:', 'color: #27ae60;', formId);
    //   console.groupEnd();

      // 6. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'newsletter_signup',
        element_location: elementLocation,
        form_id: formId,
        page_path: currentPath // Added page path as requested
      });

      // 7. Success Console Badge
      //console.log('%c✅ SUCCESS: GA4 newsletter signup verified for ' + currentPath, 'background: #27ae60; color: #fff; padding: 2px 5px;');

    } catch (err) {
      console.error('❌ GA4 newsletter_signup Error:', err);
    }
  }
};


/**
 * 14. Resource Click Tracking (Clinical Papers)
 * Captures clicks on cards that open PDFs via window.open()
 */
const initResourceClickTracking = () => {
  // We attach to the body/document and look for the specific card class
  document.addEventListener('click', function(event) {
    // 1. Find the closest clinical card container
    const card = event.target.closest('.mlv-clinical-card');
    
    // 2. Check if the click was on the Download button (we want to exclude it here)
    const isDownloadBtn = event.target.closest('.mlvdownload-link');

    if (card && !isDownloadBtn) {
      try {
        // 3. Get the title and strip the SVG/icon text
        const titleElement = card.querySelector('.mlvcard-title');
        let paperTitle = '';

        if (titleElement) {
          // Clone the element to remove the span/svg without affecting the UI
          const tempTitle = titleElement.cloneNode(true);
          const iconSpan = tempTitle.querySelector('.mlv-title-icon');
          if (iconSpan) iconSpan.remove();
          paperTitle = tempTitle.textContent.trim();
        } else {
          paperTitle = 'Unknown Clinical Paper';
        }

        const resourceType = 'clinical_paper';

        // 4. Individual Value Logs
        // console.group('📄 GA4 Custom Event: resource_click');
        // console.log('%cPaper Title:', 'color: #8e44ad; font-weight: bold;', paperTitle);
        // console.log('%cResource Type:', 'color: #8e44ad;', resourceType);
        // console.groupEnd();

        // 5. DataLayer Push
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'resource_click',
          element_text: paperTitle,
          resource_type: resourceType
        });

        // 6. Success Console
        //console.log('%c✅ SUCCESS: GA4 "resource_click" fired!', 'background: #8e44ad; color: #fff; padding: 2px 5px;');

      } catch (err) {
        console.error('❌ GA4 resource_click Error:', err);
      }
    }
  }, true); // Use 'true' for capture phase to ensure it hits before window.open
};



/**
 * 15. View Item List Tracking (Collection Grid) - FIXED
 * Fix: Resets tracking on grid changes and ensures all items are captured.
 */

const initCollectionListViewTracking = () => {
  const gridContainer = document.querySelector('.collection__cards');
  if (!gridContainer) return;

  const getListInfo = () => {
    const rawListId = window.location.pathname.split('/').pop() || 'all-products';
    const rawListName = document.querySelector('.collection__header-info__title-text')?.textContent.trim() || 'Search Result';
    return {
      id: rawListId.substring(0, 100),
      name: rawListName.substring(0, 100)
    };
  };

  const currency = window.shopCurrency || 'USD';
  let currentViewTrackedIds = new Set();

  const trackVisibleItems = () => {
    const listInfo = getListInfo();
    const productCards = gridContainer.querySelectorAll('product-card');
    const newItems = [];

    productCards.forEach((card, index) => {
      const productId = card.getAttribute('data-product-id') || card.querySelector('[data-product-id]')?.getAttribute('data-product-id');
      
      if (productId && !currentViewTrackedIds.has(productId)) {
        const rawTitle = card.querySelector('product-card-title')?.textContent.trim() || 'Unknown Product';
        
        // const priceElement = card.querySelector('product-card-price, .price, .money');
        // let price = 0;
        // if (priceElement) {
        //   const cleanPrice = priceElement.textContent.replace(/[^\d.]/g, '');
        //   price = parseFloat(cleanPrice) || 0;
        // }

          const priceElement = card.querySelector('product-card-price, .price, .money');
      let price = 0;
      if (priceElement) {
        // const cleanPrice = priceElement.textContent.replace(/[^\d.]/g, '');
        const cleanPrice = priceElement.getAttribute("data-price").replace(/[^\d.]/g, '')
        
        price = parseFloat(cleanPrice) || 0;
      }

        newItems.push({
          item_id: String(productId),
          item_name: rawTitle,
          item_brand: 'Candela',
          item_category: listInfo.name,
          index: index,
          item_list_id: listInfo.id,
          item_list_name: listInfo.name,
          price: price,
          quantity: 1 // Added quantity here
        });

        currentViewTrackedIds.add(productId);
      }
    });

    if (newItems.length > 0) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null }); 
      window.dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          currency: currency,
          item_list_id: listInfo.id,
          item_list_name: listInfo.name,
          items: newItems
        }
      });

    //   console.group('%c🗂️ GA4: view_item_list (' + newItems.length + ' items)', 'background: #f39c12; color: #fff; padding: 2px 5px;');
    //   console.table(newItems);
    //   console.groupEnd();
    }
  };

  window.requestAnimationFrame(() => {
    setTimeout(trackVisibleItems, 1000); 
  });

  const observer = new MutationObserver((mutations) => {
    currentViewTrackedIds = new Set(); 
    clearTimeout(window._collectionObserverTimeout);
    window._collectionObserverTimeout = setTimeout(() => {
      trackVisibleItems();
    }, 800); 
  });

  observer.observe(gridContainer, { childList: true, subtree: true });
};


/**
 * 16. Select Item Tracking (Collection Grid Click)
 * Updated with Brand, Category, consistent IDs, and cleaned item data.
 * QA
 */
/**
 * Select Item Tracking (Collection Grid Click)
 * Added: quantity: 1 and improved price parsing.
 */
const initSelectItemTracking = () => {
  const gridContainer = document.querySelector('.collection__cards');
  if (!gridContainer) return;

  gridContainer.addEventListener('click', function(event) {
    const productLink = event.target.closest('.product-card__link');
    if (!productLink) return;

    const card = productLink.closest('product-card');
    if (!card) return;

    try {
      // 1. Contextual Info
      const rawListId = window.location.pathname.split('/').pop() || 'all-products';
      const listId = rawListId.substring(0, 100);

      const rawListName = document.querySelector('.collection__header-info__title-text')?.textContent.trim() || 'Collection';
      const listName = rawListName.substring(0, 100);
      
      // 2. Product ID
      const productId = (card.getAttribute('data-product-id') || '').substring(0, 100);

      const rawProductTitle = card.querySelector('product-card-title')?.textContent.trim() || 'Unknown Product';
      const productTitle = rawProductTitle.substring(0, 100);
      
      // 3. Position (1-based index)
      const allCards = Array.from(gridContainer.querySelectorAll('product-card'));
      const index = allCards.indexOf(card);

      // // 4. Price Logic (Improved Regex)
      // const priceElement = card.querySelector('product-card-price, .price, .money');
      // let price = 0;
      // if (priceElement) {
      //   const cleanPrice = priceElement.textContent.replace(/[^\d.]/g, '');
      //   price = parseFloat(cleanPrice) || 0;
      // }
       // 4. Price Logic (Improved Regex)
      const priceElement = card.querySelector('product-card-price, .price, .money');
      let price = 0;
      if (priceElement) {
        // const cleanPrice = priceElement.textContent.replace(/[^\d.]/g, '');
        const cleanPrice = priceElement.getAttribute("data-price").replace(/[^\d.]/g, '')
        
        price = parseFloat(cleanPrice) || 0;
      }

      const currency = window.shopCurrency || 'USD';

      // 5. Construct Item Object (With Quantity)
      const itemData = {
        item_id: productId,
        item_name: productTitle,
        item_brand: 'Candela',
        item_category: listName,
        index: index,
        item_list_id: listId,
        item_list_name: listName,
        price: price,
        quantity: 1 // Added quantity
      };

      const finalPayload = {
        event: 'select_item',
        ecommerce: {
          currency: currency,
          item_list_id: listId,
          item_list_name: listName,
          items: [itemData]
        }
      };

      // 6. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null }); 
      window.dataLayer.push(finalPayload);

      // 7. Logging
    //   console.group('%c🖱️ GA4 ECOMMERCE: select_item', 'background: #3498db; color: #fff; padding: 2px 5px; font-weight: bold;');
    //   console.log('Item Selected:', productTitle);
    //   console.log('Payload:', finalPayload);
    //   console.groupEnd();

    } catch (err) {
      console.error('❌ GA4 select_item Error:', err);
    }
  }, true);
};


/**
 * 17. Support Click Tracking
 * Fires when the "Help Center" link in the header utility bar is clicked.
 */
const initSupportClickTracking = () => {
  // 1. Identify the Help Center link
  const helpCenterLink = document.querySelector('.mlvhelpcenterlink');

  if (helpCenterLink) {
    helpCenterLink.addEventListener('click', function() {
      try {
        const elementLocation = 'header_bar';

        // 2. Individual Value Logs for Debugging
        // console.group('🛠️ GA4 Custom Event: support_click');
        // console.log('%cElement Location:', 'color: #e67e22; font-weight: bold;', elementLocation);
        // console.log('%cTarget URL:', 'color: #e67e22;', this.href);
        // console.groupEnd();

        // 3. DataLayer Push
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'support_click',
          element_location: elementLocation
        });

        // 4. Success Console Badge
        //console.log('%c✅ SUCCESS: GA4 "support_click" fired!', 'background: #e67e22; color: #fff; padding: 2px 5px;');

      } catch (err) {
        console.error('❌ GA4 support_click Error:', err);
      }
    });
  }
};

/**
 * 18. Login Click Tracking
 * Fires when the "My Account" link in the header utility bar is clicked.
 */
const initLoginClickTracking = () => {
  // 1. Target the specific link within the account container
  const loginLink = document.querySelector('.mlvaccount .secondary-nav__link');

  if (loginLink) {
    loginLink.addEventListener('click', function() {
      try {
        const elementLocation = 'header_bar';

        // 2. Individual Value Logs for Debugging
        // console.group('👤 GA4 Recommended Event: login');
        // console.log('%cElement Location:', 'color: #2980b9; font-weight: bold;', elementLocation);
        // console.log('%cAction:', 'color: #2980b9;', 'Utility Bar Login Click');
        // console.groupEnd();

        // 3. DataLayer Push
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'login',
          element_location: elementLocation
        });

        // 4. Success Console Badge
        //console.log('%c✅ SUCCESS: GA4 "login" event fired!', 'background: #2980b9; color: #fff; padding: 2px 5px;');

      } catch (err) {
        console.error('❌ GA4 login click Error:', err);
      }
    });
  }
};

/**
 * 19. Mobile Navigation Trigger Tracking
 * Fires when a user taps the hamburger menu to open the mobile drawer.
 */
const initMobileNavTracking = () => {
  // 1. Target the specific mobile menu trigger container
  const mobileMenuBtn = document.querySelector('.js-mobile-draw-icon button');

  if (mobileMenuBtn) {
    mobileMenuBtn.addEventListener('click', function() {
      try {
        const navItem = 'hamburger_menu';
        const navLevel = 'primary';
        const elementLocation = 'header';

        // 2. Individual Value Logs for Debugging
        // console.group('📱 GA4 Custom Event: nav_click (Mobile)');
        // console.log('%cNav Item:', 'color: #16a085; font-weight: bold;', navItem);
        // console.log('%cNav Level:', 'color: #16a085;', navLevel);
        // console.log('%cLocation:', 'color: #16a085;', elementLocation);
        // console.groupEnd();

        // 3. DataLayer Push
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'nav_click',
          nav_item: navItem,
          nav_level: navLevel,
          element_location: elementLocation
        });

        // 4. Success Console Badge
       // console.log('%c✅ SUCCESS: GA4 "nav_click" fired!', 'background: #16a085; color: #fff; padding: 2px 5px;');

      } catch (err) {
        console.error('❌ GA4 nav_click Error:', err);
      }
    });
  }
};


/**
 * 20. Logo Navigation Tracking
 * Fires when a user clicks the logo in the header to return home.
 */
const initLogoClickTracking = () => {
  // 1. Target the logo link specifically
  const logoLink = document.querySelector('.header__logo-link');

  if (logoLink) {
    // 2. Use capture phase (true) to ensure the event fires before navigation
    logoLink.addEventListener('click', function() {
      try {
        const navItem = 'logo';
        const navLevel = 'primary';
        const elementLocation = 'header';

        // 3. Console Debugging
        // console.group('🏠 GA4 Custom Event: nav_click (Logo)');
        // console.log('%cNav Item:', 'color: #8e44ad; font-weight: bold;', navItem);
        // console.log('%cLocation:', 'color: #8e44ad;', elementLocation);
        // console.groupEnd();

        // 4. DataLayer Push
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null }); // Best practice to clear if preceding ecommerce events
        window.dataLayer.push({
          event: 'nav_click',
          nav_item: navItem,
          nav_level: navLevel,
          element_location: elementLocation
        });

        // 5. Success Badge
        //console.log('%c✅ SUCCESS: GA4 "nav_click" (logo) fired!', 'background: #8e44ad; color: #fff; padding: 2px 5px;');

      } catch (err) {
        console.error('❌ GA4 logo_click Error:', err);
      }
    }, true); 
  }
};


/**
 * 21. Final Unified Navigation Tracking
 * Captures Desktop & Mobile navigation, excluding CTA items.
 * Updated with 100 character maximum length for event parameter values.
 * 🧭 Navigation Tracking
 * Fix: When "Explore" is clicked, captures the product name from .cmm-text-wrap
 */
const initNavigationTracking = () => {
  document.body.addEventListener('click', function(event) {
    
    // 1. Identify the clickable element
    const target = event.target.closest('.primary-nav__items a, .cmm-tab, summary.list-menu__link, .cmm-shop-link');
    if (!target) return;

    // 2. EXCLUSION: Skip Cart/CTA items
    const isCartCta = target.closest('.secondary-nav__item--cart') || 
                      target.closest('.js-cart-draw-icon') || 
                      target.classList.contains('js-cart-icon');
    
    if (isCartCta) return;

    // 3. Extract and Clean Text
    let rawNavItem = target.innerText.split('\n')[0].trim();
    
    // --- QA FIX: Handle "Explore" links in Product Menu ---
    if (rawNavItem.toLowerCase() === 'explore') {
      // Find the specific pane this "Explore" link belongs to
      const parentPane = target.closest('.cmm-pane');
      const productTitle = parentPane ? parentPane.querySelector('.cmm-text-wrap h3') : null;
      
      if (productTitle) {
        rawNavItem = productTitle.innerText.trim();
      }
    }
    
    let navItem = rawNavItem.substring(0, 100);
    
    // 4. EXCLUSION: Skip "Contact us"
    if (navItem.toLowerCase().includes('contact us')) return;

    // 5. Determine nav_level
    let navLevel = 'primary';
    const isDesktopSub = target.closest('.nav__sub') || target.closest('.cmm-native-wrapper');
    const isMobileSub = target.closest('.drawer-nav__panel');

    if (isDesktopSub || isMobileSub) {
      navLevel = 'dropdown';
    }

    // 6. Fire Event
    if (navItem !== "") {
      try {
        const elementLocation = 'header'.substring(0, 100);
        const finalNavLevel = navLevel.substring(0, 100);

        const pushData = {
          event: 'nav_click',
          nav_item: navItem,
          nav_level: finalNavLevel,
          element_location: elementLocation
        };

        // Verification Log
        // console.log(
        //   `%c🧭 NAV CLICK: ${navItem}`, 
        //   'background: #2980b9; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;',
        //   pushData
        // );

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(pushData);

      } catch (err) {
        console.error('❌ GA4 Navigation Error:', err);
      }
    }
  }, true);
};
/**
 * 23. Currency/Locale Selection Tracking
 */
const initCurrencyTracking = () => {
  const localizeWrapper = document.querySelector('.js-secondary-nav-localize');
  if (!localizeWrapper) return;

  localizeWrapper.addEventListener('click', function(event) {
    const item = event.target.closest('.js-localize-item');
    if (!item) return;

    let rawText = item.innerText || item.textContent;
    let currencyValue = rawText.replace(/\s+/g, ' ').trim();

    if (currencyValue) {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'currency_select',
          currency_value: currencyValue
        });

        // Success Log
        //console.log(`%c✅ SUCCESS: currency_select event fired | Value: ${currencyValue}`, 'background: #27ae60; color: #fff; padding: 2px 5px; border-radius: 3px;');

      } catch (err) {
        console.error('❌ GA4 Currency Tracking Error:', err);
      }
    }
  });
};



/**
 * 24. Hero Carousel Unified Tracking
 * Handles CTA clicks (click_cta) and Pagination (carousel_interact)
 * Updated with 100 character maximum length for event parameter values.
 */
const initHeroCarouselTracking = () => {
  const carousel = document.querySelector('media-carousel.home-carousel');
  if (!carousel) return;

  // 1. CTA Click Tracking
  carousel.addEventListener('click', (event) => {
    const cta = event.target.closest('.home-carousel__btn');
    if (!cta) return;

    const slide = cta.closest('media-carousel-slide');
    // Swiper uses 0-based index in data-swiper-slide-index
    const slideIndex = parseInt(slide.getAttribute('data-swiper-slide-index')) + 1;
    
    // Scrape, Clean, and Truncate Text (Max 100 Chars)
    const rawText = cta.innerText.trim();
    const elementText = rawText.substring(0, 100);
    
    // Prepare and Truncate Location (Max 100 Chars)
    const elementLocation = `hero_slide_${slideIndex}`.substring(0, 100);

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'click_cta',
        element_text: elementText,
        element_location: elementLocation
      });

      //console.log(`%c✅ SUCCESS: click_cta | Text: ${elementText} | Loc: ${elementLocation}`, 'background: #f39c12; color: #fff; padding: 2px 5px; border-radius: 3px;');
    } catch (err) {
      console.error('❌ GA4 CTA Error:', err);
    }
  });

  // 2. Pagination Dot Tracking
  const paginationContainer = carousel.querySelector('.js-carousel-pagination');
  if (paginationContainer) {
    paginationContainer.addEventListener('click', (event) => {
      const dot = event.target.closest('.swiper-pagination-bullet');
      if (!dot) return;

      // Find index by counting previous siblings
      const dots = Array.from(paginationContainer.querySelectorAll('.swiper-pagination-bullet'));
      const dotIndex = dots.indexOf(dot) + 1;

      try {
        // Prepare and Truncate Section/Action (Max 100 Chars)
        const carouselSection = 'hero'.substring(0, 100);
        const carouselAction = 'dot_click'.substring(0, 100);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'carousel_interact',
          carousel_section: carouselSection,
          carousel_action: carouselAction,
          // carousel_index: dotIndex
        });

        //console.log(`%c✅ SUCCESS: carousel_interact | Section: ${carouselSection} | Index: ${dotIndex}`, 'background: #8e44ad; color: #fff; padding: 2px 5px; border-radius: 3px;');
      } catch (err) {
        console.error('❌ GA4 Carousel Error:', err);
      }
    });
  }
};


/**
 * 25. Product Spotlight CTA Tracking
 * Uses custom functional class to avoid issues with dynamic Shopify IDs
 */
const initProductSpotlightTracking = () => {
  // Target the specific button within the index template
  const spotlightBtn = document.querySelector('.template-index .ga-spotlight-btn');
  
  if (!spotlightBtn) return;

  spotlightBtn.addEventListener('click', function(event) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'click_cta',
        element_text: 'Explore Glace',
        element_location: 'product_spotlight'
      });

      // Verification Log
      //console.log('%c✅ TRACKED: Product Spotlight CTA', 'background: #6e2b62; color: #fff; padding: 2px 5px; border-radius: 3px;');
    } catch (err) {
      console.error('❌ GA4 Spotlight Tracking Error:', err);
    }
  });
};


/**
 * 26. Glacē Serum Carousel Interaction
 * Tracks navigation through the serum cards with dynamic section naming
 * Updated with 100 character maximum length for event parameter values.
 */
const initSerumCarouselTracking = () => {
  const prevArrows = document.querySelectorAll('.gps-arrow-prev');
  const nextArrows = document.querySelectorAll('.gps-arrow-next');

  // Helper function to push dataLayer events
  const pushCarouselEvent = (btn, action) => {
    // Navigate up to find the wrapper, then find the H2 text
    const wrapper = btn.closest('.gps-wrapper');
    const sectionHeading = wrapper ? wrapper.querySelector('.gps-header h2') : null;
    
    // Scrape and Truncate (Max 100 Chars)
    const rawSection = sectionHeading ? sectionHeading.innerText.trim() : 'Serum Carousel';
    const dynamicSection = rawSection.substring(0, 100);
    const carouselAction = action.substring(0, 100);

    const pushData = {
      event: 'carousel_interact',
      carousel_section: dynamicSection,
      carousel_action: carouselAction
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(pushData);
    
    // Debug log with distinct color
    // console.log(
    //   `%c↔️ CAROUSEL: ${carouselAction} | Section: ${dynamicSection}`, 
    //   'background: #008080; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;',
    //   pushData
    // );
  };

  // Attach listeners to all Prev buttons
  prevArrows.forEach(btn => {
    btn.addEventListener('click', () => pushCarouselEvent(btn, 'prev_click'));
  });

  // Attach listeners to all Next buttons
  nextArrows.forEach(btn => {
    btn.addEventListener('click', () => pushCarouselEvent(btn, 'next_click'));
  });
};



/**
 * 27. Footer Logo Tracking
 * Specifically targets the logo link within the footer structure
 */
const initFooterLogoTracking = () => {
  const footerLogo = document.querySelector('.footer-nav__image-link');

  if (!footerLogo) return;

  footerLogo.addEventListener('click', function() {
    try {
      // Define the data payload
      const pushData = {
        event: 'nav_click',
        nav_item: 'logo',
        nav_level: 'footer',
        element_location: 'footer'
      };

      // Push to dataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Detailed Verification Log
    //   console.log(
    //     '%c📍 DataLayer Push (Footer Logo):', 
    //     'background: #000; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
    //     pushData
    //   );
      
    } catch (err) {
      console.error('❌ GA4 Footer Logo Tracking Error:', err);
    }
  });
};


/**
 * Footer Navigation Tracking
 * FIX: Prevents extra 'click' events and ignores non-anchor link elements.
 */
const initFooterGeneralNavTracking = () => {
  const footer = document.querySelector('footer[role="contentinfo"]');
  if (!footer) return;

  footer.addEventListener('click', function(event) {
    // 1. Target the actual anchor tag (<a>) specifically
    const target = event.target.closest('a.footer-nav__link');
    
    // 2. If no anchor found, or it's in excluded sections (logo/social), stop
    if (!target || target.closest('.footer-nav--image') || target.closest('.footer-nav--social')) {
      return;
    }

    const linkText = target.innerText.trim();

    // 3. EXCLUSION LOGIC
    const excludedLinks = ['Contact Us', 'Schedule Demo'];
    if (excludedLinks.includes(linkText)) return;

    try {
      // 4. Stop other generic 'click' events from firing on this same element
      event.stopImmediatePropagation();

      const pushData = {
        event: 'nav_click',
        nav_item: linkText,
        nav_level: 'footer',
        element_location: 'footer'
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Detailed Verification Log
    //   console.log(
    //     `%c🔗 FOOTER NAV: ${linkText}`, 
    //     'background: #6e2b62; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
    //     pushData
    //   );
    } catch (err) {
      console.error('❌ GA4 Footer Nav Tracking Error:', err);
    }
  }, { capture: true }); // Using capture phase to intercept the click early
};


/**
 * 29. Cart Drawer 'Shop Now' CTA Tracking
 * Tracks the button shown when the cart drawer is opened and empty.
 */
const initCartEmptyTracking = () => {
  // We use event delegation on the document because cart drawers are 
  // often dynamically injected into the DOM when opened.
  document.addEventListener('click', function(event) {
    const shopNowBtn = event.target.closest('cart-empty a.c-btn');
    
    if (!shopNowBtn) return;

    try {
      const pushData = {
        event: 'click_cta',
        element_text: 'Shop Now',
        element_location: 'cart_drawer'
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Detailed Verification Log
    //   console.log(
    //     '%c🛒 CART: Empty State Shop Now Clicked', 
    //     'background: #2b6e4e; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
    //     pushData
    //   );
    } catch (err) {
      console.error('❌ GA4 Cart Empty Tracking Error:', err);
    }
  });
};


/**
 * 30. Back to Top Tracking
 * Tracks the specific <back-to-top-button> custom element
 */
const initBackToTopTracking = () => {
  // Use event delegation to handle the button regardless of when it becomes visible
  document.addEventListener('click', function(event) {
    // Check if the click or its parent is the back-to-top custom element
    const bttButton = event.target.closest('back-to-top-button');

    if (!bttButton) return;

    try {
      const pushData = {
        event: 'back_to_top_click'
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Detailed Verification Log
    //   console.log(
    //     '%c🔝 NAVIGATION: Back To Top Clicked', 
    //     'background: #34495e; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
    //     pushData
    //   );
    } catch (err) {
      console.error('❌ GA4 Back to Top Tracking Error:', err);
    }
  });
};


/* Glace Landing Page */

/**
 * 31. Before/After Case Selection Tracking
 * Tracks when a user switches between different patient result cases.
 */
const initBeforeAfterTracking = () => {
  // Use event delegation on the tabs container
  const tabsContainer = document.querySelector('#after-before .cba-tabs-container');
  
  if (!tabsContainer) return;

  tabsContainer.addEventListener('click', function(event) {
    // Ensure the clicked element is a tab button
    const tabBtn = event.target.closest('.cba-tab-btn');
    
    if (!tabBtn) return;

    // Get the case name (e.g., "Case 1") and clean whitespace
    const caseName = tabBtn.innerText.trim();

    try {
      const pushData = {
        event: 'before_after_select',
        element_text: caseName,
        element_location: 'before_after_section'
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Detailed Verification Log
    //   console.log(
    //     `%c📸 CASE STUDY: ${caseName} Selected`, 
    //     'background: #6e2b62; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
    //     pushData
    //   );
    } catch (err) {
      console.error('❌ GA4 Before/After Tracking Error:', err);
    }
  });
};


/**
 * 32. Before/After Slider Interaction Tracking
 * Fires once per drag release if the position has changed from 50%.
 */
const initBeforeAfterSliderTracking = () => {
  // Use delegation to handle all sliders in the container
  const cbaContainer = document.querySelector('#after-before');
  if (!cbaContainer) return;

  const handleDragEnd = (event) => {
    const sliderInput = event.target.closest('.cba-slider-input');
    if (!sliderInput) return;

    const currentPosition = parseInt(sliderInput.value, 10);

    // Omit from first load/default position: 
    // Only fire if the user has moved it away from the center (50)
    if (currentPosition === 50) return;

    // Read active case text from the DOM
    const activeTab = document.querySelector('.cba-tab-btn.active');
    const caseLabel = activeTab ? activeTab.innerText.trim() : 'Unknown Case';

    try {
      const pushData = {
        event: 'before_after_drag',
        element_text: caseLabel,
        slide_position: currentPosition,
        element_location: 'before_after_section'
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Detailed Verification Log
    //   console.log(
    //     `%c↔️ SLIDER: ${caseLabel} moved to ${currentPosition}%`, 
    //     'background: #3498db; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
    //     pushData
    //   );
    } catch (err) {
      console.error('❌ GA4 Slider Drag Tracking Error:', err);
    }
  };

  // Attach to both mouse and touch release events
  cbaContainer.addEventListener('mouseup', handleDragEnd);
  cbaContainer.addEventListener('touchend', handleDragEnd);
};


/**
 * 33. Success Story Video Tracking
 * Tracks the first time a user clicks the overlay to play the video.
 */
const initSuccessVideoTracking = () => {
  const videoBlock = document.querySelector('.csuccess-video-block');
  if (!videoBlock) return;

  const videoElement = videoBlock.querySelector('video');
  const overlay = videoBlock.querySelector('.csuccess-video-overlay-ui');
  
  // Guard flag to ensure the event only fires once per page load
  let hasVideoStarted = false;

  if (overlay && videoElement) {
    overlay.addEventListener('click', function() {
      // Only fire if the video hasn't been started yet
      if (!hasVideoStarted) {
        try {
          const pushData = {
            event: 'video_start',
            video_title: 'How Glacē Transformed Our Med Spa Revenue',
            element_location: 'success_stories_section'
          };

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(pushData);

          // Set flag to true to prevent re-firing on pause/resume
          hasVideoStarted = true;

          // Detailed Verification Log
        //   console.log(
        //     '%c🎥 VIDEO: Start Detected', 
        //     'background: #e67e22; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
        //     pushData
        //   );
        } catch (err) {
          console.error('❌ GA4 Video Tracking Error:', err);
        }
      }
    });
  }
};


/**
 * 34. Success Story Video Progress Tracking
 * Tracks milestones at 25%, 50%, and 75% completion.
 */
// const initSuccessVideoProgress = () => {
//   const video = document.querySelector('.csuccess-video-bg');
//   if (!video) return;

//   // Track which milestones have been triggered to prevent duplicates
//   const triggeredMilestones = new Set();
//   const targetMilestones = [25, 50, 75];

//   video.addEventListener('timeupdate', () => {
//     // Ensure duration is available to avoid NaN
//     if (!video.duration) return;

//     const currentTime = video.currentTime;
//     const duration = video.duration;
//     const percentComplete = Math.floor((currentTime / duration) * 100);

//     targetMilestones.forEach(milestone => {
//       // If the current percentage has reached the milestone and we haven't tracked it yet
//       if (percentComplete >= milestone && !triggeredMilestones.has(milestone)) {
        
//         try {
//           const pushData = {
//             event: 'video_progress',
//             video_title: 'How Glacē Transformed Our Med Spa Revenue',
//             video_percent: milestone,
//             element_location: 'success_stories_section'
//           };

//           window.dataLayer = window.dataLayer || [];
//           window.dataLayer.push(pushData);

//           // Mark this milestone as triggered
//           triggeredMilestones.add(milestone);

//           // Detailed Verification Log
//           console.log(
//             `%c🎞️ VIDEO PROGRESS: ${milestone}%`, 
//             'background: #d35400; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
//             pushData
//           );
//         } catch (err) {
//           console.error('❌ GA4 Video Progress Error:', err);
//         }
//       }
//     });
//   });

//   // Optional: Reset milestones if the video ends and the user restarts it
//   video.addEventListener('ended', () => {
//     triggeredMilestones.clear();
//   });
// };
const initSuccessVideoProgress = () => {
  const video = document.querySelector('.csuccess-video-bg');
  if (!video) return;

  // Track which milestones have been triggered to prevent duplicates
  const triggeredMilestones = new Set();
  const targetMilestones = [25, 50, 75];

  // Function to ensure we don’t fire the event too frequently
  let lastFiredTime = 0;
  const THROTTLE_INTERVAL = 200; // 200ms throttle interval

  video.addEventListener('timeupdate', () => {
    // Ensure duration is available and valid to avoid NaN
    if (!video.duration || video.duration <= 0 || !video.currentTime) return;

    // Throttle to prevent firing too often
    const currentTime = video.currentTime;
    const duration = video.duration;
    const percentComplete = Math.floor((currentTime / duration) * 100);

    const now = Date.now();
    if (now - lastFiredTime < THROTTLE_INTERVAL) return; // Skip if throttle time hasn't passed

    // Track milestones only once
    targetMilestones.forEach(milestone => {
      if (percentComplete >= milestone && !triggeredMilestones.has(milestone)) {
        
        try {
          const pushData = {
            event: 'video_progress',
            video_title: 'How Glacē Transformed Our Med Spa Revenue',
            video_percent: milestone,
            element_location: 'success_stories_section'
          };

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(pushData);

          // Mark this milestone as triggered
          triggeredMilestones.add(milestone);

          // Update last fired time
          lastFiredTime = now;

          // Detailed Verification Log
          // console.log(
          //   `%c🎞️ VIDEO PROGRESS: ${milestone}%`, 
          //   'background: #d35400; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
          //   pushData
          // );
        } catch (err) {
          console.error('❌ GA4 Video Progress Error:', err);
        }
      }
    });
  });

  // Optional: Reset milestones if the video ends and the user restarts it
  video.addEventListener('ended', () => {
    triggeredMilestones.clear();
  });

  // Reset milestones if the user scrubs back to the beginning of the video
  video.addEventListener('seeked', () => {
    if (video.currentTime < 1) {
      triggeredMilestones.clear();
    }
  });
};


/**
 * 35. Success Story Video Completion Tracking
 * Tracks when the video reaches 100% completion.
 */
const initSuccessVideoCompletion = () => {
  const video = document.querySelector('.csuccess-video-bg');
  
  if (!video) return;

  video.addEventListener('ended', () => {
    try {
      const pushData = {
        event: 'video_complete',
        video_title: 'How Glacē Transformed Our Med Spa Revenue',
        element_location: 'success_stories_section'
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Detailed Verification Log
      console.log(
        '%c✅ VIDEO: Completion Reached', 
        'background: #27ae60; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
        pushData
      );
    } catch (err) {
      console.error('❌ GA4 Video Completion Error:', err);
    }
  });
};


/**
 * 36. Success Stories Section CTA Tracking
 * Tracks the "Buy Glacē Today" button click within the success stories section.
 */
const initSuccessStoriesCTATracking = () => {
  // Use event delegation on the grid container for efficiency
  const successGrid = document.querySelector('#glace-landing-page .csuccess-grid');

  if (!successGrid) return;

  successGrid.addEventListener('click', function(event) {
    // Target the specific button class
    const ctaBtn = event.target.closest('.csuccess-btn');

    if (!ctaBtn) return;

    try {
      // Clean the text to ensure it matches 'Buy Glacē Today' exactly
      // (Handles potential extra whitespace or icon text)
      const elementText = 'Buy Glacē Today';

      const pushData = {
        event: 'click_cta',
        element_text: elementText,
        element_location: 'success_stories_section'
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Detailed Verification Log
    //   console.log(
    //     '%c🎯 CTA CLICK: Success Stories', 
    //     'background: #2980b9; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
    //     pushData
    //   );
    } catch (err) {
      console.error('❌ GA4 Success CTA Tracking Error:', err);
    }
  });
};


/**
 * 37. ROI Calculator Interaction Tracking
 * Updated to use 'change' event and value-check to prevent duplicate firing.
 * Includes 100 character truncation for GA4 compliance.
 */
const initROICalculatorTracking = () => {
  const roiContainer = document.querySelector('.roi-container');
  if (!roiContainer) return;

  const keyMap = {
    'devicePrice': 'device_price',
    'tpd': 'treatments_per_day',
    'dpw': 'days_per_week',
    'duration': 'duration',
    'price': 'price_per_treatment',
    'consumables': 'consumables_cost',
    'staff': 'staff_rate'
  };

  // Track previous values to ensure we don't fire if the value is the same
  const previousValues = {};

  // 'change' fires only after the user modifies the content and blurs the field
  roiContainer.addEventListener('change', (event) => {
    const input = event.target;
    
    if (input.tagName === 'INPUT' && input.dataset.key) {
      const rawKey = input.dataset.key;
      const fieldName = (keyMap[rawKey] || rawKey).substring(0, 100);
      const fieldValue = parseFloat(input.value);

      // 1. Only proceed if it's a valid number
      // 2. Only proceed if the value is different from the last tracked value
      if (!isNaN(fieldValue) && previousValues[fieldName] !== fieldValue) {
        
        // Update the state tracker
        previousValues[fieldName] = fieldValue;

        try {
          const pushData = {
            event: 'roi_calc_update',
            field_name: fieldName,
            field_value: fieldValue
          };

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(pushData);

        //   console.log(
        //     `%c📊 ROI CALC: ${fieldName} updated to ${fieldValue}`, 
        //     'background: #8e44ad; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
        //     pushData
        //   );
        } catch (err) {
          console.error('❌ GA4 ROI Tracking Error:', err);
        }
      }
    }
  });
};


/**
 * 38. ROI Calculator Footer CTA Tracking
 * Tracks the "Order Glacē →" button click at the bottom of the ROI section.
 */
const initROICTATracking = () => {
  const roiSection = document.querySelector('#roi-calculator');

  if (!roiSection) return;

  roiSection.addEventListener('click', (event) => {
    // Target the specific CTA button
    const ctaBtn = event.target.closest('.roi-btn');

    if (!ctaBtn) return;

    try {
      const pushData = {
        event: 'click_cta',
        element_text: 'Order Glacē',
        element_location: 'roi_calculator_section'
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Detailed Verification Log
    //   console.log(
    //     '%c🎯 CTA CLICK: ROI Calculator', 
    //     'background: #27ae60; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
    //     pushData
    //   );
    } catch (err) {
      console.error('❌ GA4 ROI CTA Tracking Error:', err);
    }
  });
};


/**
 * 24. Demo Request Form Field Tracking
 * Fix: Captures auto-selected Country (US) when State is touched.
 * Form ID: 7153
 */
const initDemoFormTracking = () => {
  const form = document.querySelector('#mktoForm_7153');
  if (!form) return;

  const completedFields = new Set();

  const fieldMapping = {
    'FirstName': 'first_name',
    'LastName': 'last_name',
    'Company': 'company',
    'MobilePhone': 'mobile_phone',
    'Email': 'email',
    'Country': 'country',
    'State': 'state',
    'defaultstring6': 'product_interest_question'
  };

  /**
   * Core Push Logic
   */
  const triggerPush = (rawName) => {
    if (completedFields.has(rawName)) return;

    const normalizedName = fieldMapping[rawName];
    const fieldElem = form.querySelector(`[name="${rawName}"]`);
    const val = fieldElem && fieldElem.value ? fieldElem.value.trim() : '';

    if (normalizedName && val !== '') {
      try {
        const pushData = {
          event: 'form_field_complete',
          field_name: normalizedName,
          form_id: 'demo_request_form'
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(pushData);
        completedFields.add(rawName);

        // Verification Log
        // console.log(
        //   `%c📝 DEMO FORM FIELD: ${normalizedName}`, 
        //   'background: #34495e; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
        //   pushData
        // );
      } catch (err) {
        console.error('❌ GA4 Demo Form Tracking Error:', err);
      }
    }
  };

  /**
   * Logic Handler: Checks for US Auto-selection
   */
  const handleFieldCompletion = (event) => {
    const field = event.target;
    const rawName = field.getAttribute('name');
    if (!rawName) return;

    // --- US AUTO-FIRE LOGIC ---
    // If user touches 'State', fire 'Country' first if it's currently 'United States'
    if (rawName === 'State' && !completedFields.has('Country')) {
      const countryField = form.querySelector('[name="Country"]');
      if (countryField && countryField.value === 'United States') {
        triggerPush('Country');
      }
    }

    // --- STANDARD LOGIC ---
    triggerPush(rawName);
  };

  // Listeners: 'change' for selects, 'blur' for inputs
  form.addEventListener('blur', handleFieldCompletion, true);
  form.addEventListener('change', handleFieldCompletion, true);
};

/**
 * 40. Bottom Section CTA Tracking
 * Tracks the "Order Now" button click in the final full-width section.
 */
const initBottomCTATracking = () => {
  const bottomSection = document.querySelector('#glace-landing-page .ccta-wrapper');

  if (!bottomSection) return;

  bottomSection.addEventListener('click', (event) => {
    // Capture click even if user hits the SVG icon inside the button
    const ctaBtn = event.target.closest('.ccta-btn');

    if (!ctaBtn) return;

    try {
      const pushData = {
        event: 'click_cta',
        element_text: 'Order Now',
        element_location: 'bottom_cta_section'
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Detailed Verification Log
    //   console.log(
    //     '%c🏁 CTA CLICK: Bottom Section', 
    //     'background: #e67e22; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
    //     pushData
    //   );
    } catch (err) {
      console.error('❌ GA4 Bottom CTA Tracking Error:', err);
    }
  });
};


/* Glace Product Page */
/**
 * 41. Out of Stock Notification Tracking (Bulletproof version)
 * Uses the [notify-on-add] attribute to target the functional form container.
 */
const initNotifyMeTracking = () => {
  // Target by attribute for maximum reliability
  const productForm = document.querySelector('product-form[notify-on-add]');

  if (!productForm) return;

  productForm.addEventListener('click', (event) => {
    // Specifically target the CartBite/Notification button
    // This button usually co-exists with the disabled standard submit button
    const notifyBtn = event.target.closest('.gw-button-widget') || 
                      event.target.closest('[gw-stock-fulfilled]');

    if (!notifyBtn) return;

    try {
      const pushData = {
        event: 'click_cta',
        element_text: 'Notify me when available',
        element_location: 'product_form'
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Detailed Verification Log
    //   console.log(
    //     '%c🛡️ NOTIFY ME : Intent Captured', 
    //     'background: #130f40; color: #ffffff; padding: 2px 5px; border-radius: 3px;', 
    //     pushData
    //   );
    } catch (err) {
      console.error('❌ GA4 Notify Me Tracking Error:', err);
    }
  });
};




/* Default Consumable Product Page */
/* 46. Login Initiation Tracking
 * Tracks when a guest user clicks "Sign in to Continue" to purchase consumables.
 */
const initLoginCTATracking = () => {
  // Target the specific class used for the sign-in requirement
  const loginBtn = document.querySelector('.signIntoContinue');

  if (!loginBtn) return;

  loginBtn.addEventListener('click', () => {
    try {
      const pushData = {
        event: 'login',
        element_location: 'product_info'
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Verification Log
    //   console.log(
    //     '%c🔐 LOGIN INITIATED: Consumables Purchase', 
    //     'background: #2980b9; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
    //     pushData
    //   );
    } catch (err) {
      console.error('❌ GA4 Login Tracking Error:', err);
    }
  });
};



/**
 * 47. Floating Notification Widget Tracking (Capture Phase)
 * Intercepts clicks before the App can stop event propagation.
 */
const initFloatingNotifyTracking = () => {
  // We use 'true' as the third argument to trigger the CAPTURE phase.
  // This intercepts the click on its way down to the element.
  document.addEventListener('click', (event) => {
    
    // 1. Identify the container, the button, OR the invisible 'cover' div
    const isNotifyElement = event.target.closest('.restock-rocket-button-container-float-right') || 
                            event.target.closest('.restock-rocket-button-product') ||
                            event.target.closest('.restock-rocket-button-cover');

    if (!isNotifyElement) return;

    try {
      const pushData = {
        event: 'click_cta',
        element_text: 'Notify me when available',
        element_location: 'product_notify_widget'
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

    //   console.log(
    //     '%c🏷️ WIDGET CLICK: Floating Notify (Captured)', 
    //     'background: #8e44ad; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
    //     pushData
    //   );
    } catch (err) {
      console.error('❌ GA4 Floating Widget Tracking Error:', err);
    }
  }, true); // <--- CRITICAL: true enables the capture phase
};


/* See It Action Page */

/**
 * 48. Education Center Tab Tracking
 * Tracks navigation clicks within the Glacē Education Center.
 */
const initEducationTabTracking = () => {
  const navContainer = document.querySelector('.education-tabs-nav');

  if (!navContainer) return;

  navContainer.addEventListener('click', (event) => {
    // Target the specific anchor tag for the tab
    const tabLink = event.target.closest('.tab-link');

    if (!tabLink) return;

    try {
      // Dynamically capture the text, cleaning up any HTML entities like &amp;
      const tabName = tabLink.innerText.trim();

      const pushData = {
        event: 'education_tab_click',
        tab_name: tabName,
        element_location: 'education_center'
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Detailed Verification Log
    //   console.log(
    //     `%c🎓 EDUCATION NAV: ${tabName}`, 
    //     'background: #2c3e50; color: #ecf0f1; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
    //     pushData
    //   );
    } catch (err) {
      console.error('❌ GA4 Education Tab Tracking Error:', err);
    }
  });
};


/**
 * 52. Blog Resource Click Tracking
 * Captures clicks on thumbnails, titles, and "Read more" links.
 * Standardized: Payload object and grouped console logging.
 */
const initBlogResourceTracking = () => {
  const blogSection = document.querySelector('.home-blog');

  if (!blogSection) return;

  blogSection.addEventListener('click', (event) => {
    // Check if the clicked element is one of the blog links
    const blogLink = event.target.closest('.home-blog__link');
    
    if (!blogLink) return;

    // Navigate to the specific card parent to find the title
    const card = blogLink.closest('.blog');
    if (!card) return;

    try {
      // Scrape and Truncate (Max 100 Chars)
      const titleElement = card.querySelector('.blog__title');
      const rawTitle = titleElement ? titleElement.innerText.trim() : 'Unknown Article';
      
      const blogTitle = rawTitle.substring(0, 100);
      const resourceType = 'blog_post'.substring(0, 100);

      const pushData = {
        event: 'resource_click',
        element_text: blogTitle,
        resource_type: resourceType
      };

      // 1. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // 2. Standardized Console Log for QA
    //   console.group('%c📖 GA4 INTERACTION: Blog Click', 'background: #d35400; color: #fff; padding: 2px 5px; font-weight: bold;');
    //   console.log('Action: dataLayer.push()');
    //   console.log('Payload:', pushData); // Displays the pushData object clearly
    //   console.groupEnd();

    } catch (err) {
      console.error('❌ GA4 Blog Tracking Error:', err);
    }
  });
};

/**
 * 53. Blog "View All" Tracking
 * Targets the 'View all' button specifically for the Blogs section.
 * Updated with 100 character maximum length for event parameter values.
 */
const initDynamicViewAllTracking = () => {
  // Use event delegation on the body to catch all "View All" buttons site-wide
  document.body.addEventListener('click', (event) => {
    const btn = event.target.closest('.section--blog .section__link-link');
    
    // Only proceed if it's the specific "View All" style button
    if (!btn) return;

    try {
      // 1. Get and Truncate the button text (usually "View all")
      const rawText = btn.innerText.trim();
      const elementText = rawText.substring(0, 100);

      // 2. Determine Location dynamically
      const sectionWrapper = btn.closest('.section__content') || btn.closest('.container');
      const sectionHeader = sectionWrapper ? sectionWrapper.querySelector('.section__title-text, h2') : null;
      
      let rawLocation = 'general_section';
      if (sectionHeader) {
        rawLocation = sectionHeader.innerText.trim().toLowerCase().replace(/\s+/g, '_') + '_section';
      } else if (btn.getAttribute('href')) {
        const path = btn.getAttribute('href').split('/')[1]; // gets 'blogs' or 'collections'
        rawLocation = (path || 'general') + '_section';
      }

      // Truncate Location (Max 100 Chars)
      const location = rawLocation.substring(0, 100);

      const pushData = {
        event: 'click_cta',
        element_text: elementText,
        element_location: location
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Verification Log
    //   console.log(
    //     `%c🔗 CTA CLICKED: [${elementText}] in [${location}]`, 
    //     'background: #2c3e50; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
    //     pushData
    //   );
    } catch (err) {
      console.error('❌ GA4 Dynamic CTA Tracking Error:', err);
    }
  });
};

/**
 * 54. FAQ Footer Contact CTA Tracking
 * Tracks clicks on the Contact Us button at the bottom of the FAQ page.
 */
const initFAQContactTracking = () => {
  const faqFooter = document.querySelector('.cfaq-footer');
  if (!faqFooter) return;

  const contactBtn = faqFooter.querySelector('a.cfaq-btn');
  if (!contactBtn) return;

  contactBtn.addEventListener('click', function() {
    try {
      const elementText = this.innerText.trim() || 'Contact Us';
      const elementLocation = 'faq_footer';

      const pushData = {
        event: 'click_cta',
        element_text: elementText,
        element_location: elementLocation
      };

      // 1. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // 2. Success Badge
    //   console.log(
    //     `%c✅ SUCCESS: GA4 "click_cta" fired for: ${elementText}`, 
    //     'background: #16a085; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;'
    //   );

      // 3. Data Snapshot Table (Prevents "No properties" on redirect)
    //   console.table([{
    //     event: 'click_cta',
    //     text: elementText,
    //     location: elementLocation,
    //     destination: this.href
    //   }]);

    } catch (err) {
      console.error('❌ GA4 FAQ Contact Tracking Error:', err);
    }
  });
};

/**
 * Helper: Detects page type and returns the appropriate location prefix.
 * If URL contains /search, returns 'search', otherwise 'collection'.
 */
const getPageContext = () => {
  return window.location.pathname.includes('/search') ? 'search' : 'collection';
};

/**
 * 55. Mobile Filter & Sort CTA Tracking
 * Updated with 100 character maximum length for event parameter values.
 */
const initMobileFilterCTA = () => {
  document.addEventListener('click', function(event) {
    const filterBtn = event.target.closest('.collection-main__filter-btn');
    if (!filterBtn) return;

    try {
      const context = getPageContext();
      // Scrape and Truncate (Max 100 Chars)
      const rawText = filterBtn.innerText.trim() || 'Filter and sort';
      const elementText = rawText.substring(0, 100);
      
      // Prepare and Truncate Location (Max 100 Chars)
      const elementLocation = `${context}_toolbar`.substring(0, 100);

      const pushData = {
        event: 'click_cta',
        element_text: elementText,
        element_location: elementLocation // Becomes 'search_toolbar' or 'collection_toolbar'
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      //console.log(`%c✅ SUCCESS: GA4 "click_cta" (${context})`, 'background: #34495e; color: #fff; padding: 2px 5px;');
    } catch (err) {
      console.error('❌ GA4 Mobile Filter CTA Error:', err);
    }
  });
};



/**
 * Collection Filter Removal Tracking
 * Updated: Detects if the click is in the sidebar (panel) or toolbar (pills).
 */
const initClearAllFiltersTracking = () => {
  document.addEventListener('click', function(event) {
    // 1. Identify the clicked filter trigger
    const filterBtn = event.target.closest('.js-filter-trigger');
    if (!filterBtn) return;

    try {
      // 2. Determine Action Type
      const isClearAll = filterBtn.classList.contains('collection__filters-active__filter--clear') || 
                         filterBtn.innerText.toLowerCase().includes('clear all');
      
      const isIndividualRemove = filterBtn.querySelector('.icon--close') || 
                                 filterBtn.classList.contains('collection__filters-active__filter');

      if (!isClearAll && !isIndividualRemove) return;

      // 3. Determine Context and Location
      const context = typeof getPageContext === 'function' ? getPageContext() : 'collection';
      
      // Check if the button is inside the sidebar drawer/panel
      const isInsideSidebar = filterBtn.closest('.collection-sidebar, .collection-sidebar__draw-actions, #drawer-filter');
      const locationSuffix = isInsideSidebar ? '_filter_panel' : '_toolbar';
      
      let pushData = {
        event: 'collection_filter',
        element_location: `${context}${locationSuffix}`
      };

      if (isClearAll) {
        // --- Logic for "Clear All" ---
        pushData.filter_type = 'clear';
        pushData.filter_value = 'clear_all';
      } else {
        // --- Logic for Individual Pill Removal ---
        const rawText = filterBtn.innerText.trim();
        
        pushData.filter_type = 'clear'; 
        pushData.filter_value = rawText;
      }

      // 4. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // 5. Verification Log
    //   console.group('%c🔍 GA4 FILTER: ' + (isClearAll ? 'Clear All' : 'Remove Pill'), 'background: #e67e22; color: #fff; padding: 2px 5px;');
    //   console.log('Location:', pushData.element_location);
    //   console.log('Payload:', pushData);
    //   console.groupEnd();

    } catch (err) {
      console.error('❌ GA4 Filter Tracking Error:', err);
    }
  });
};

/**
 * 57. Sort Selection Tracking
 */
const initSortTracking = () => {
  document.addEventListener('change', function(event) {
    const sortSelect = event.target.closest('.js-collection-sort');
    if (!sortSelect) return;

    try {
      const context = getPageContext();
      const selectedOption = sortSelect.options[sortSelect.selectedIndex];
      const sortValue = selectedOption ? selectedOption.text.trim() : '';
      
      const pushData = {
        event: 'collection_sort',
        sort_value: sortValue,
        element_location: `${context}_filter_panel` // Dynamic location
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

    //   console.log(`%c✅ SUCCESS: GA4 "collection_sort" (${context})`, 'background: #2980b9; color: #fff; padding: 2px 5px;');
    //   console.table([pushData]);
    } catch (err) {
      console.error('❌ GA4 Sort Tracking Error:', err);
    }
  });
};


/**
 * 58. Accordion Expand Tracking (Dynamic Location)
 * Fix: Added unique timestamps and state clearing to ensure every 
 * interaction generates a unique network request.
 */
const initAccordionObserver = () => {
  const cooldowns = new Map();
  const observerOptions = { attributes: true, attributeFilter: ['open'] };

  const attachObservers = () => {
    const targetNodes = document.querySelectorAll('.collection-sidebar__filter-group');
    
    targetNodes.forEach(node => {
      if (node.dataset.observed) return;
      node.dataset.observed = 'true';

      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          const detailsTag = mutation.target;
          
          // Check if it's being opened
          if (detailsTag.hasAttribute('open')) {
            const now = Date.now();
            const lastFired = cooldowns.get(detailsTag) || 0;
            
            // Cooldown to prevent double-firing on single clicks
            if (now - lastFired < 500) continue; 

            try {
              const context = getPageContext(); 
              const summary = detailsTag.querySelector('.collection-sidebar__filter-trigger');
              const labelSpan = summary ? summary.querySelector('span') : null;
              
              const rawText = labelSpan ? labelSpan.innerText.trim() : 'Unknown Filter Group';
              const elementText = rawText.substring(0, 100);
              const elementLocation = `${context}_filter_panel`.substring(0, 100);

              // Clear the object first to ensure GTM sees this as a fresh change
              window.dataLayer = window.dataLayer || [];
              
              const pushData = {
                event: 'accordion_expand',
                element_text: elementText,
                element_location: elementLocation,
                // Add a timestamp to the payload to force a unique network hit
                _ts: now 
              };

              window.dataLayer.push(pushData);
              cooldowns.set(detailsTag, now);

              // Detailed log for QA to see the exact payload sent
            //   console.group('%c✅ GA4 EVENT: accordion_expand', 'background: #8e44ad; color: #fff; padding: 2px 5px;');
            //   console.log('Payload:', pushData);
            //   console.groupEnd();

            } catch (err) {
              console.error('❌ GA4 Observer Error:', err);
            }
          }
        }
      });
      
      observer.observe(node, observerOptions);
    });
  };

  attachObservers();

  // Watch for AJAX content updates
  const bodyObserver = new MutationObserver(() => {
    attachObservers();
  });

  bodyObserver.observe(document.body, { childList: true, subtree: true });
};

/**
 * 59. Availability Filter Tracking (Dynamic Location)
 * Handles "In stock" and "Out of stock" checkbox interactions.
 */
const initAvailabilityFilterTracking = () => {
  document.addEventListener('change', function(event) {
    const checkbox = event.target;
    
    // 1. Target only the availability filter checkboxes
    if (checkbox.name !== 'filter.v.availability') return;

    try {
      // 2. Identify Page Context (collection vs search)
      const context = typeof getPageContext === 'function' ? getPageContext() : 'collection';
      
      // 3. Normalise Filter Value
      const availabilityMap = { '0': 'out_of_stock', '1': 'in_stock' };
      const normalizedValue = availabilityMap[checkbox.value] || 'unknown';

      // 4. Determine Filter Action
      const action = checkbox.checked ? 'apply' : 'remove';

      // 5. Construct Payload
      const pushData = {
        event: 'collection_filter',
        filter_type: 'availability',
        filter_value: normalizedValue,
        filter_action: action,
        element_location: `${context}_filter_panel`
      };

      // 6. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // 7. Verification Log
    //   console.group('%c✅ GA4 FILTER: Availability', 'background: #27ae60; color: #fff; padding: 2px 5px; font-weight: bold;');
    //   console.log(`Action: ${action.toUpperCase()}`);
    //   console.log(`Value: ${normalizedValue}`);
    //   console.log('Payload:', pushData);
    //   console.groupEnd();

    } catch (err) {
      console.error('❌ GA4 Availability Filter Error:', err);
    }
  });
};


/**
 * Collection Model Filter Tracking
 * Target: Model checkboxes in the sidebar (Salesforce Model Filter)
 */
const initModelFilterTracking = () => {
  // Use event delegation to handle AJAX/Dynamic re-renders of the filter panel
  document.addEventListener('change', function(event) {
    const checkbox = event.target;
    
    // Targeting the specific Salesforce model filter attribute
    if (checkbox.name !== 'filter.p.m.salesforce.salesforce_model_filter') return;

    try {
      const context = typeof getPageContext === 'function' ? getPageContext() : 'collection';
      
      // 1. Determine Action (checked → 'apply', unchecked → 'remove')
      const filterAction = checkbox.checked ? 'apply' : 'remove';

      // 2. Scrape Value and Location
      const filterValue = (checkbox.value || '').substring(0, 100);
      const elementLocation = `${context}_filter_panel`;

      // 3. Construct DataLayer Object
      const pushData = {
        event: 'collection_filter',
        filter_type: 'model',
        filter_value: filterValue,
        filter_action: filterAction, // Updated parameter name to filter_action
        element_location: elementLocation
      };

      // 4. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // 5. Verification Log
    //   console.group('%c🔍 GA4 FILTER: Model', 'background: #3498db; color: #fff; padding: 2px 5px; font-weight: bold;');
    //   console.log(`Action: ${filterAction.toUpperCase()}`);
    //   console.log(`Model: ${filterValue}`);
    //   console.log('Payload:', pushData);
    //   console.groupEnd();

    } catch (err) {
      console.error('❌ GA4 Model Filter Error:', err);
    }
  });
};



/**
 * 61. Category Filter Tracking (Dynamic Location)
 * Standardized: filter_action set to 'apply'/'remove' and synced with documentation.
 */
const initCategoryFilterTracking = () => {
  document.addEventListener('change', function(event) {
    const checkbox = event.target;
    
    // Target only the category filter inputs (Shopify Product Type)
    if (checkbox.name !== 'filter.p.product_type') return;

    try {
      const context = typeof getPageContext === 'function' ? getPageContext() : 'collection';
      
      // 1. Determine Action State (checked → 'apply', unchecked → 'remove')
      const filterAction = checkbox.checked ? 'apply' : 'remove';

      // 2. Scrape and Truncate (Max 100 Chars)
      const filterValue = (checkbox.value || 'unknown_category').substring(0, 100);
      const elementLocation = `${context}_filter_panel`.substring(0, 100);

      // 3. Construct DataLayer Object
      const pushData = {
        event: 'collection_filter',
        filter_type: 'category',
        filter_value: filterValue,
        filter_action: filterAction, // Updated to match required schema
        element_location: elementLocation
      };

      // 4. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // 5. Verification Log
    //   console.group('%c🔍 GA4 FILTER: Category', 'background: #e67e22; color: #fff; padding: 2px 5px; font-weight: bold;');
    //   console.log(`Action: ${filterAction.toUpperCase()}`);
    //   console.log(`Category: ${filterValue}`);
    //   console.log('Payload:', pushData);
    //   console.groupEnd();

    } catch (err) {
      console.error('❌ GA4 Category Tracking Error:', err);
    }
  });
};


/**
 *  Filter Modal "View Results" CTA Tracking (Mobile)
 * Captures the 'click_cta' event when applying filters on mobile.
 */

const initFilterViewResultsTracking = () => {
  document.addEventListener('click', function(event) {
    // 1. Identify the button: Look for a button containing "View (" inside the action container
    const btn = event.target.closest('.collection-sidebar__draw-actions button');
    
    // Only proceed if the button exists and contains the text "View ("
    if (!btn || !btn.innerText.includes('View (')) return;

    try {
      const context = getPageContext(); // Helper call
      
      // 2. Extract and Truncate (Max 100 Chars)
      const elementText = btn.innerText.trim().substring(0, 100);
      const elementLocation = `${context}_filter_panel`.substring(0, 100);

      // 3. Prepare Data
      const pushData = {
        event: 'click_cta',
        element_text: elementText,
        element_location: elementLocation
      };

      // 4. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // 5. Updated Verification Log
      // Now displays the 'pushData' object for easy inspection
    //   console.log(
    //     `%c🔘 CTA CLICK: ${elementText}`, 
    //     'background: #27ae60; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;',
    //     pushData
    //   );

    } catch (err) {
      console.error('❌ GA4 View Results Click Error:', err);
    }
  });
};

/**
 * 62. Price Range Filter Tracking (Updated for Sliders)
 * Captures min and max prices from both numeric inputs and slider tracks.
 */
const initPriceRangeTracking = () => {
  let priceTimeout;

  document.addEventListener('change', function(event) {
    const input = event.target;
    
    // 1. Check if the element is part of the price filter (Input or Range Slider)
    const isNumericInput = input.classList.contains('price-range__number');
    const isRangeSlider = input.classList.contains('price-range__input');
    
    if (!isNumericInput && !isRangeSlider) return;

    // 2. Debounce the event so we don't fire multiple times if inputs sync up
    clearTimeout(priceTimeout);
    priceTimeout = setTimeout(() => {
      try {
        const context = getPageContext();
        const priceContainer = input.closest('price-range');
        if (!priceContainer) return;

        // Target the numeric inputs specifically to get the "final" values
        // Shopify themes usually sync the slider value into these inputs
        const minInput = priceContainer.querySelector('input[name="filter.v.price.gte"]');
        const maxInput = priceContainer.querySelector('input[name="filter.v.price.lte"]');

        // Capture values
        const minValue = minInput.value || minInput.placeholder || '0';
        const maxValue = maxInput.value || maxInput.placeholder || '0';
        const rangeString = `${minValue}-${maxValue}`;

        const pushData = {
          event: 'collection_filter',
          filter_type: 'price',
          filter_value: rangeString,
          element_location: `${context}_filter_panel`
        };

        // 3. DataLayer Push
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(pushData);

        // Success Badge
        // console.log(
        //   `%c✅ SUCCESS: GA4 "collection_filter" (Price Range: ${rangeString})`, 
        //   'background: #f1c40f; color: #000; padding: 2px 5px; border-radius: 3px; font-weight: bold;'
        // );
        // console.table([pushData]);

      } catch (err) {
        console.error('❌ GA4 Price Range Filter Error:', err);
      }
    }, 300); // 300ms debounce
  });
};


/**
 * 63. Search Result Click Tracking
 * Captures clicks on Page and Article results in the search grid.
 * Updated with 100 character maximum length for event parameter values.
 */
const initSearchResultClickTracking = () => {
  document.addEventListener('click', (event) => {
    // 1. Identify if a non-product search result was clicked
    const cardLink = event.target.closest('.search-grid-item__link');
    if (!cardLink) return;

    try {
      const card = cardLink.querySelector('.search-grid-item');
      if (!card) return;

      // 2. Extract and Truncate Result Type (Max 100 chars)
      const labelElement = card.querySelector('.label__text');
      let rawResultType = labelElement ? labelElement.innerText.trim().toLowerCase() : 'other';
      if (rawResultType === 'blog') rawResultType = 'article'; // Normalize "Blog" badge to "article"
      const resultType = rawResultType.substring(0, 100);

      // 3. Extract and Truncate Result Title (Max 100 chars)
      const titleElement = card.querySelector('.search-grid-item__content__title');
      const rawResultTitle = titleElement ? titleElement.innerText.trim() : '';
      const resultTitle = rawResultTitle.substring(0, 100);

      // 4. Calculate 1-based Position
      const allResults = Array.from(document.querySelectorAll('.js-results .o-layout__item'));
      const parentItem = cardLink.closest('.o-layout__item');
      const resultPosition = allResults.indexOf(parentItem) + 1;

      // 5. Get and Truncate Search Term from URL parameter 'q' (Max 100 chars)
      const urlParams = new URLSearchParams(window.location.search);
      const rawSearchTerm = urlParams.get('q') || '';
      const searchTerm = rawSearchTerm.substring(0, 100);

      const pushData = {
        event: 'search_result_click',
        result_type: resultType,
        result_title: resultTitle,
        result_position: resultPosition,
        search_term: searchTerm
      };

      // 6. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Success Badge
    //   console.log(
    //     `%c🔎 CLICK: search_result_click (${resultType})`, 
    //     'background: #3498db; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;'
    //   );
    //   console.table([pushData]);

    } catch (err) {
      console.error('❌ GA4 Search Click Error:', err);
    }
  });
};


/* About Us */

/**
 * 64. About Hero CTA Click Tracking
 * Captures "Order from Candela" and "Contact Us" buttons.
 */
const initAboutHeroClickTracking = () => {
  document.addEventListener('click', (event) => {
    // 1. Target links inside the buttons-row within the innovation-content block
    const ctaLink = event.target.closest('.innovation-content .buttons-row a');
    if (!ctaLink) return;

    // 2. Extract and clean text
    const elementText = ctaLink.innerText.trim();
    
    // 3. Filter for specific buttons only
    const validButtons = ['Order from Candela', 'Contact Us'];
    if (!validButtons.includes(elementText)) return;

    try {
      const pushData = {
        event: 'click_cta',
        element_text: elementText,
        element_location: 'about_hero'
      };

      // 4. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Success Badge (Green for CTAs)
    //   console.log(
    //     `%c🎯 CTA CLICK: ${elementText}`, 
    //     'background: #27ae60; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;'
    //   );
    //   console.table([pushData]);

    } catch (err) {
      console.error('❌ GA4 About Hero CTA Error:', err);
    }
  });
};



/**
 * 65. Charity Carousel Tracking (Giving Back Section)
 * Dynamically captures heading and interaction details.
 */
const initCharityCarouselTracking = () => {
  document.addEventListener('click', (event) => {
    const target = event.target;
    
    // 1. Check if the click is within the specific "Giving Back" slider container
    const sliderContainer = target.closest('.gb-slider-container');
    if (!sliderContainer) return;

    let carouselAction = '';
    let carouselIndex = null;

    // 2. Identify Interaction Type
    if (target.closest('.gb-prev')) {
      carouselAction = 'prev';
    } 
    else if (target.closest('.gb-next')) {
      carouselAction = 'next';
    } 
    else if (target.closest('.gb-dot')) {
      carouselAction = 'dot_click';
      const dot = target.closest('.gb-dot');
      const allDots = Array.from(sliderContainer.querySelectorAll('.gb-dot'));
      carouselIndex = allDots.indexOf(dot) + 1;
    }

    if (!carouselAction) return;

    try {
      // 3. Scrape Heading for carousel_section (Consistency fix)
      // Matches the .gb-heading element from your HTML snippet
      const rawHeading = document.querySelector('.gb-heading')?.textContent.trim() || 'Giving Back';
      const carouselSection = rawHeading.substring(0, 100);

      // 4. Construct DataLayer Object
      const pushData = {
        event: 'carousel_interact',
        carousel_section: carouselSection,
        carousel_action: carouselAction
      };

      if (carouselAction === 'dot_click' && carouselIndex !== null) {
        pushData.carousel_index = carouselIndex;
      }

      // 5. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null }); 
      window.dataLayer.push(pushData);

      // 6. Standardized Console Log for QA
    //   console.group('%c🎠 GA4 INTERACTION: Carousel', 'background: #8e44ad; color: #fff; padding: 2px 5px; font-weight: bold;');
    //   console.log('Action: dataLayer.push()');
    //   console.log('Payload:', pushData);
    //   console.groupEnd();

    } catch (err) {
      console.error('❌ GA4 Carousel Tracking Error:', err);
    }
  });
};


/**
 * 66. Leadership Carousel Tracking
 * Dynamically captures heading and interaction details.
 */
const initLeadershipCarouselTracking = () => {
  document.addEventListener('click', (event) => {
    // 1. Target the specific leadership slider container
    const sliderContainer = event.target.closest('.lead-slider-container');
    if (!sliderContainer) return;

    let carouselAction = '';

    // 2. Identify if Prev or Next was clicked
    if (event.target.closest('.lead-prev')) {
      carouselAction = 'prev';
    } else if (event.target.closest('.lead-next')) {
      carouselAction = 'next';
    }

    if (!carouselAction) return;

    try {
      // 3. Scrape Heading for carousel_section
      // Targets .lead-heading as provided in your HTML snippet
      const rawHeading = document.querySelector('.lead-heading')?.textContent.trim() || 'Leadership';
      const carouselSection = rawHeading.substring(0, 100);

      const pushData = {
        event: 'carousel_interact',
        carousel_section: carouselSection,
        carousel_action: carouselAction
      };

      // 4. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null }); // Clear potential leftovers
      window.dataLayer.push(pushData);

      // 5. Standardized Console Log for QA
    //   console.group('%c👥 GA4 INTERACTION: Carousel', 'background: #f39c12; color: #fff; padding: 2px 5px; font-weight: bold;');
    //   console.log('Action: dataLayer.push()');
    //   console.log('Payload:', pushData);
    //   console.groupEnd();

    } catch (err) {
      console.error('❌ GA4 Leadership Carousel Error:', err);
    }
  });
};


/**
 * 67. Blog Research Section CTA Tracking
 * Captures "View Glacē Device" and "Request Pricing" below article content.
 * Updated with 100 character maximum length for event parameter values.
 */
const initBlogDeviceCtaTracking = () => {
  document.addEventListener('click', (event) => {
    // 1. Scope to the specific blog CTA button row
    const ctaLink = event.target.closest('.ml-ready-glace__buttons a.mlvctabtn');
    if (!ctaLink) return;

    // 2. Extract, clean, and truncate text (Max 100 chars)
    const rawText = ctaLink.innerText.trim();
    const elementText = rawText.substring(0, 100);
    
    try {
      // Prepare location with truncation safety
      const elementLocation = 'blog_cta_section'.substring(0, 100);

      const pushData = {
        event: 'click_cta',
        element_text: elementText,
        element_location: elementLocation
      };

      // 3. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Console log for local QA
    //   console.log(
    //     `%c📝 BLOG CTA: ${elementText}`, 
    //     'background: #34495e; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;'
    //   );

    } catch (err) {
      console.error('❌ GA4 Blog CTA Tracking Error:', err);
    }
  });
};



/**
 * 68. Related Articles Click Tracking
 * Fires only if URL contains '/blogs' AND '.related-articles-grid' exists.
 * Captures title of dynamic article cards and truncates to 100 characters.
 */
const initRelatedArticlesTracking = () => {
  // 1. URL and Element Gate: Only run if path contains '/blogs' AND grid is present
  const hasGrid = document.querySelector('.related-articles-grid');
  if (!window.location.pathname.includes('/blogs') || !hasGrid) return;

  document.addEventListener('click', (event) => {
    // 2. Identify the card link (ra-card or blog link)
    const cardLink = event.target.closest('.related-articles-grid .ra-card, .blog .blog-link');
    if (!cardLink) return;

    try {
      // 3. Locate the heading within the clicked card and truncate (Max 100 chars)
      const titleElement = cardLink.querySelector('.ra-content h3, .blog__title.h2');
      const rawTitle = titleElement ? titleElement.innerText.trim() : 'Title Not Found';
      
      const articleTitle = rawTitle.substring(0, 100);
      const resourceType = 'blog_post'.substring(0, 100);

      const pushData = {
        event: 'resource_click',
        element_text: articleTitle,
        resource_type: resourceType
      };

      // 4. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // 5. Standardized Console Log for Verification
    //   console.group('%c📖 GA4 INTERACTION: Resource Click', 'background: #2980b9; color: #fff; padding: 2px 5px; font-weight: bold;');
    //   console.log('Action: dataLayer.push()');
    //   console.log('Payload:', pushData); 
    //   console.groupEnd();

    } catch (err) {
      console.error('❌ GA4 Related Articles Error:', err);
    }
  });
};

/**
 * 52. Blog Listing Resource Click Tracking
 * Captures clicks on thumbnails, titles, and "Read Article/more" links.
 * Works for both Featured and Grid items on the blog listing page.
 */
const initBlogListingTracking = () => {
  // Target the main container for the blog list
  const blogListContainer = document.querySelector('.blog__items');

  if (!blogListContainer) return;

  blogListContainer.addEventListener('click', (event) => {
    // 1. Identify if the click is on a blog-related link
    // Targets: .blog-link (images/titles) and button-style links
    const blogLink = event.target.closest('a[href*="/blogs/"]');
    
    if (!blogLink) return;

    // 2. Navigate to the parent .blog card to find the title
    const card = blogLink.closest('.blog');
    if (!card) return;

    try {
      // 3. Scrape Title: Targets both standard .blog__title and .featured-blog__title
      const titleElement = card.querySelector('.blog__title');
      const rawTitle = titleElement ? titleElement.innerText.trim() : 'Unknown Article';
      
      const blogTitle = rawTitle.substring(0, 100);
      const resourceType = 'blog_post'.substring(0, 100);

      const pushData = {
        event: 'resource_click',
        element_text: blogTitle,
        resource_type: resourceType
      };

      // 4. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // 5. Standardized Console Log for QA
    //   console.group('%c📖 GA4 INTERACTION: Blog Listing Click', 'background: #d35400; color: #fff; padding: 2px 5px; font-weight: bold;');
    //   console.log('Action: dataLayer.push()');
    //   console.log('Payload:', pushData);
    //   console.groupEnd();

    } catch (err) {
      console.error('❌ GA4 Blog Listing Tracking Error:', err);
    }
  });
};


/**
 * Contact Form Field Tracking
 * Fix: Captures auto-selected Country (US) when State is touched.
 * Handles manual country changes for non-US customers normally.
 */
const initContactFormTracking = () => {
  const form = document.querySelector('#mktoForm_7150');
  if (!form) return;

  const completedFields = new Set();

  const fieldMapping = {
    'FirstName': 'first_name',
    'LastName': 'last_name',
    'Company': 'company',
    'MobilePhone': 'mobile_phone',
    'Email': 'email',
    'Country': 'country',
    'State': 'state',
    'defaultstring6': 'message'
  };

  const getFormLocationId = () => {
    const path = window.location.pathname;
    if (path === '/') return 'homepage_contact_form';
    if (path.includes('/pages/contact')) return 'contact_us_form';
    return 'general_contact_form';
  };

  const triggerPush = (rawName) => {
    if (completedFields.has(rawName)) return;

    const normalizedName = fieldMapping[rawName];
    const fieldElem = form.querySelector(`[name="${rawName}"]`);
    const val = fieldElem && fieldElem.value ? fieldElem.value.trim() : '';

    if (normalizedName && val !== '') {
      try {
        const activeFormId = getFormLocationId();
        const pushData = {
          event: 'form_field_complete',
          field_name: normalizedName,
          form_id: activeFormId
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(pushData);
        completedFields.add(rawName);

        // console.log(
        //   `%c📝 FORM FIELD [${activeFormId}]: ${normalizedName}`, 
        //   'background: #2c3e50; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;', 
        //   pushData
        // );
      } catch (err) {
        console.error('❌ GA4 Form Field Tracking Error:', err);
      }
    }
  };

  const handleFieldLogic = (field) => {
    const rawName = field.getAttribute('name');
    if (!rawName) return;

    // --- US AUTO-FIRE LOGIC ---
    // If the user interacts with 'State', it means Country is likely 'United States'
    // We fire the Country event immediately if it hasn't fired yet.
    if (rawName === 'State' && !completedFields.has('Country')) {
      triggerPush('Country');
    }

    // --- STANDARD LOGIC ---
    triggerPush(rawName);
  };

  // Keep your working listeners
  form.addEventListener('change', (event) => handleFieldLogic(event.target));
  form.addEventListener('blur', (event) => handleFieldLogic(event.target), true);
};




/**
 * 70. 404 Page CTA Tracking
 * Captures the "Continue shopping" button click on the error page.
 */
const init404CtaTracking = () => {
  document.addEventListener('click', (event) => {
    // 1. Target the link inside the 404 section
    const ctaLink = event.target.closest('.section--404 a.c-btn');
    if (!ctaLink) return;

    // 2. Extract and clean text
    const elementText = ctaLink.innerText.trim();
    
    // 3. Validation - specifically for "Continue shopping"
    if (elementText !== 'Continue shopping') return;

    try {
      const pushData = {
        event: 'click_cta',
        element_text: elementText,
        element_location: '404_page'
      };

      // 4. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Console Log for QA
    //   console.log(
    //     `%c⚠️ 404 RECOVERY: ${elementText}`, 
    //     'background: #e74c3c; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;'
    //   );

    } catch (err) {
      console.error('❌ GA4 404 CTA Error:', err);
    }
  });
};


/**
 * 74. Cart Conflict Modal Tracking
 * Captures the 'Understood' dismissal button.
 */
const initCartConflictTracking = () => {
  document.addEventListener('click', (event) => {
    // 1. Target the 'Understood' button specifically within the conflict modal
    const understoodBtn = event.target.closest('.glace-modal-content .btn-understood');
    if (!understoodBtn) return;

    try {
      const pushData = {
        event: 'click_cta',
        element_text: 'Understood',
        element_location: 'cart_conflict_modal'
      };

      // 2. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Console Log for Verification
    //   console.log(
    //     `%c🛡️ MODAL DISMISS: Understood`, 
    //     'background: #3498db; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;'
    //   );

    } catch (err) {
      console.error('❌ GA4 Cart Conflict Tracking Error:', err);
    }
  });
};

/**
 * 75. Cart Conflict Modal Tracking - Clear Cart
 * Captures the 'Clear Cart' action which triggers a cart reset.
 */
const initCartClearTracking = () => {
  document.addEventListener('click', (event) => {
    // 1. Target the 'Clear Cart' button specifically within the conflict modal
    const clearCartBtn = event.target.closest('.glace-modal-content .btn-clear-cart');
    if (!clearCartBtn) return;

    try {
      const pushData = {
        event: 'click_cta',
        element_text: 'Clear Cart',
        element_location: 'cart_conflict_modal'
      };

      // 2. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // Console Log for Verification
    //   console.log(
    //     `%c🧹 CART ACTION: Clear Cart`, 
    //     'background: #e67e22; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;'
    //   );

    } catch (err) {
      console.error('❌ GA4 Cart Clear Tracking Error:', err);
    }
  });
};


/**
 * Blog Article Link Tracking
 * Fires 'click_cta' for any link clicked within the article body.
 */
const initArticleLinkTracking = () => {
  // Select the specific article body container
  const articleBody = document.querySelector('.article__content[itemprop="articleBody"]');
  
  if (!articleBody) return;

  articleBody.addEventListener('click', (event) => {
    // Find the closest anchor tag in case of nested spans/images
    const link = event.target.closest('a');
    
    if (link) {
      // 1. Get the text content and trim whitespace
      let rawText = link.innerText || link.textContent || 'Link without text';
      
      // 2. Enforce Max Character Length of 100
      const cleanText = rawText.trim().substring(0, 100);

      const payload = {
        event: 'click_cta',
        element_text: cleanText,
        element_location: 'blog_article_body'
      };

      // Push to DataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(payload);

      // Debugging
    //   console.group('%c🔗 GA4: Blog Link Click', 'background: #8e44ad; color: #fff; padding: 2px 5px; font-weight: bold;');
    //   console.log('Final Text (max 100):', payload.element_text);
    //   console.log('Original Length:', rawText.length);
    //   console.log('Payload:', payload);
    //   console.groupEnd();
    }
  });
};



/**
 * 19. Select Item Tracking (Cart Drawer)
 * Added: quantity from cart.js and fixed 1-based index logic.
 */
const initCartDrawerSelectItemTracking = () => {
  // Scoped to the specific Drawer ID
  const drawer = document.querySelector('#drawer-cart');
  if (!drawer) return;

  drawer.addEventListener('click', async (event) => {
    // 1. Identify if the click was on a product image link or title link
    const link = event.target.closest('.cart-item__media a, .cart-item__header a');
    if (!link) return;

    // 2. Find the parent cart item container
    const itemContainer = link.closest('cart-item');
    if (!itemContainer) return;

    try {
      // 3. Fetch current cart state for accurate IDs and Categories
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await response.json();

      // 4. Match using 'key' attribute
      const itemKey = itemContainer.getAttribute('key');
      const clickedItem = cart.items.find(item => item.key === itemKey);

      if (clickedItem) {
        // 1-based index based on position in the Shopify Cart object
        const index = cart.items.indexOf(clickedItem);

        // 5. DataLayer Reset
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });

        // 6. Construct Item Data
        const itemData = {
          item_id: clickedItem.product_id.toString().substring(0, 100),
          item_name: (clickedItem.product_title || '').substring(0, 100),
          item_brand: (clickedItem.vendor || 'Candela').substring(0, 100),
          item_category: (clickedItem.product_type || '').substring(0, 100),
          price: clickedItem.final_price / 100,
          quantity: clickedItem.quantity, // Added: Dynamic quantity
          index: index,
          item_list_id: 'cart_drawer',
          item_list_name: 'Cart Drawer'
        };

        // Add variant if it's not the default
        if (clickedItem.variant_title && clickedItem.variant_title !== 'Default Title') {
          itemData.item_variant = clickedItem.variant_title.substring(0, 100);
        }

        const finalPayload = {
          event: 'select_item',
          ecommerce: {
            currency: cart.currency,
            item_list_id: 'cart_drawer',
            item_list_name: 'Cart Drawer',
            items: [itemData]
          }
        };

        // 7. Push to DataLayer
        window.dataLayer.push(finalPayload);

        // 8. Console Logging
        // console.group('%c🛒 GA4 ECOMMERCE: select_item (Drawer)', 'background: #27ae60; color: #fff; padding: 2px 5px; font-weight: bold;');
        // console.log('Action: dataLayer.push()');
        // console.log('Payload:', finalPayload);
        // console.table([itemData]);
        // console.groupEnd();
      }
    } catch (err) {
      console.error('❌ GA4 Drawer select_item Error:', err);
    }
  });
};

/**
 * 70. CartBite (STOQ) Notify Me: Email Field Tracking
 * Fires 'form_field_complete' on blur if the email field is not empty.
 * Uses MutationObserver to handle JS-injected content.
 */
const initCartBiteNotifyMeTracking = () => {
  const targetNode = document.body;

  // Configuration for the observer
  const config = { childList: true, subtree: true };

  const observer = new MutationObserver((mutationsList, observer) => {
    // Look for the injected email input
    const emailInput = document.getElementById('form-Email');

    if (emailInput && !emailInput.dataset.trackingInitialized) {
      // Mark as initialized to prevent duplicate listeners
      emailInput.dataset.trackingInitialized = 'true';

      emailInput.addEventListener('blur', function() {
        const emailValue = this.value.trim();

        // Only fire if the field is not empty (PII is NOT captured)
        if (emailValue !== "") {
          try {
            const fieldName = 'email'.substring(0, 100);
            const formId = 'notify_me_modal'.substring(0, 100);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              event: 'form_field_complete',
              field_name: fieldName,
              form_id: formId
            });

            // Verification Log
            // console.log(
            //   `%c📧 FORM FIELD COMPLETE: ${fieldName} in ${formId}`, 
            //   'background: #8e44ad; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;'
            // );
          } catch (err) {
            console.error('❌ GA4 Notify Me Tracking Error:', err);
          }
        }
      });
      
      // Optional: If you only need to find this once, you could disconnect 
      // but keeping it active handles modals being closed and reopened.
    }
  });

  // Start observing the body for the modal injection
  observer.observe(targetNode, config);
};


/**
 * 71. CartBite (STOQ) Lead Generation Tracking
 * Fires 'generate_lead' when the success message appears in the modal.
 * Updated with 100 character maximum length for string parameters.
 */
const initCartBiteLeadTracking = () => {
  const targetNode = document.body;
  const config = { childList: true, subtree: true };

  const observer = new MutationObserver((mutationsList) => {
    // 1. Check if the Success Content container exists in the DOM
    const successContainer = document.getElementById('form-Success-Content');

    if (successContainer && !successContainer.dataset.leadTracked) {
      // Prevent duplicate fires for the same success message
      successContainer.dataset.leadTracked = 'true';

      try {
        // 2. Data Scrapping
        // Attempt to get price from the product card or global window object
        // Fallback to 0 if not found
        const priceElement = document.querySelector('.product__price .money, product-info .price-item--sale');
        let productPrice = 0;
        if (priceElement) {
          productPrice = parseFloat(priceElement.textContent.replace(/[^0-9.]/g, '')) || 0;
        }

        const currency = (window.shopCurrency || 'USD').substring(0, 100);
        const elementLocation = 'notify_me_modal'.substring(0, 100);

        // 3. DataLayer Push
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'notify_me',
          element_location: elementLocation
         
          // lead_id is omitted as STOQ does not expose a unique lead UUID in the DOM
        });

        // 4. Verification Log
        // console.log(
        //   `%c🎯 LEAD GENERATED: Notify Me Success `, 
        //   'background: #27ae60; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;'
        // );

      } catch (err) {
        console.error('❌ GA4 Lead Tracking Error:', err);
      }
    }
  });

  observer.observe(targetNode, config);
};


/**
 * 72. Education Center Video Progress Tracking
 * Tracks milestones at 25%, 50%, and 75%.
 * Pulls title from the associated .card-title element.
 */
// const initGlaceVideoProgressTracking = () => {
//   const video = document.getElementById('glacePlayer');
//   if (!video) return;

//   // Track milestones to prevent duplicate firing
//   const milestones = {
//     25: false,
//     50: false,
//     75: false
//   };

//   let activeVideoTitle = 'Education Center Video';

//   // 1. Capture the title when a play button is clicked
//   document.addEventListener('click', (event) => {
//     const playBtn = event.target.closest('.play-overlay');
//     if (!playBtn) return;

//     const card = playBtn.closest('.education-grid .content-card');
//     if (card) {
//       const titleElement = card.querySelector('.card-title');
//       activeVideoTitle = titleElement ? titleElement.innerText.trim() : 'Education Center Video';
//     }
//   });

//   // 2. Track milestones during playback
//   video.addEventListener('timeupdate', function() {
//     if (!video.duration) return;

//     // Calculate percentage
//     const progress = (video.currentTime / video.duration) * 100;
//     const currentMilestones = [25, 50, 75];

//     currentMilestones.forEach(milestone => {
//       // If we've passed the milestone and haven't tracked it yet
//       if (progress >= milestone && !milestones[milestone]) {
//         milestones[milestone] = true;

//         try {
//           // Enforce 100 character maximum length
//           const videoTitle = activeVideoTitle.substring(0, 100);
//           const elementLocation = 'education_center'.substring(0, 100);

//           // 3. DataLayer Push
//           window.dataLayer = window.dataLayer || [];
//           window.dataLayer.push({
//             event: 'video_progress',
//             video_title: videoTitle,
//             video_percent: milestone, 
//             element_location: elementLocation
//           });

//           // 4. Verification Log
//           console.log(
//             `%c📹 VIDEO PROGRESS: ${milestone}% | ${videoTitle}`, 
//             'background: #1abc9c; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;'
//           );

//         } catch (err) {
//           console.error('❌ GA4 Video Progress Error:', err);
//         }
//       }
//     });
//   });

//   // Reset milestones when the video starts over
//   video.addEventListener('play', function() {
//     if (video.currentTime < 1) {
//       milestones[25] = false;
//       milestones[50] = false;
//       milestones[75] = false;
//     }
//   });
// };
/**
 * 72. Education Center Video Progress Tracking
 * Tracks milestones at 25%, 50%, and 75%.
 * Pulls title from the associated .card-title element.
 */
const initGlaceVideoProgressTracking = () => {
  const video = document.getElementById('glacePlayer');
  if (!video) return;

  // Track milestones to prevent duplicate firing
  const milestones = {
    25: false,
    50: false,
    75: false
  };

  let activeVideoTitle = 'Education Center Video';

  // 1. Capture the title when a play button is clicked
  document.addEventListener('click', (event) => {
    const playBtn = event.target.closest('.play-overlay');
    if (!playBtn) return;

    const card = playBtn.closest('.education-grid .content-card');
    if (card) {
      const titleElement = card.querySelector('.card-title');
      activeVideoTitle = titleElement ? titleElement.innerText.trim() : 'Education Center Video';
    }
  });

  // 2. Track milestones during playback
  video.addEventListener('timeupdate', function() {
    if (!video.duration || video.duration === Infinity || video.duration === 0) return;

    // Calculate percentage
    const progress = (video.currentTime / video.duration) * 100;
    const currentMilestones = [25, 50, 75];

    currentMilestones.forEach(milestone => {
      // If we've passed the milestone and haven't tracked it yet
      if (progress >= milestone && !milestones[milestone]) {
        milestones[milestone] = true;

        try {
          // Enforce 100 character maximum length
          const videoTitle = activeVideoTitle.substring(0, 100);
          const elementLocation = 'education_center'.substring(0, 100);

          // 3. DataLayer Push
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'video_progress',
            video_title: videoTitle,
            video_percent: milestone, 
            element_location: elementLocation
          });

          // 4. Verification Log
          // console.log(
          //   `%c📹 VIDEO PROGRESS: ${milestone}% | ${videoTitle}`, 
          //   'background: #1abc9c; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;'
          // );

        } catch (err) {
          console.error('❌ GA4 Video Progress Error:', err);
        }
      }
    });
  });

  // Reset milestones when the video starts over
  video.addEventListener('play', function() {
    if (video.currentTime < 1) {
      milestones[25] = false;
      milestones[50] = false;
      milestones[75] = false;
    }
  });
};


/**
 * 73. Education Center Video Complete Tracking
 * Fires 'video_complete' when the video reaches the end.
 * Pulls title from the associated .card-title element.
 */
const initGlaceVideoCompleteTracking = () => {
  const video = document.getElementById('glacePlayer');
  if (!video) return;

  let activeVideoTitle = 'Education Center Video';

  // 1. Capture the title when a play button is clicked
  document.addEventListener('click', (event) => {
    const playBtn = event.target.closest('.play-overlay');
    if (!playBtn) return;

    const card = playBtn.closest('.education-grid .content-card');
    if (card) {
      const titleElement = card.querySelector('.card-title');
      activeVideoTitle = titleElement ? titleElement.innerText.trim() : 'Education Center Video';
    }
  });

  // 2. Fire the complete event
  video.addEventListener('ended', function() {
    try {
      // Enforce 100 character maximum length
      const videoTitle = activeVideoTitle.substring(0, 100);
      const elementLocation = 'education_center'.substring(0, 100);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'video_complete',
        video_title: videoTitle,
        element_location: elementLocation
      });

      // Verification Log
    //   console.log(
    //     `%c🏁 VIDEO COMPLETE: ${videoTitle}`, 
    //     'background: #2c3e50; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;'
    //   );

    } catch (err) {
      console.error('❌ GA4 Video Complete Error:', err);
    }
  });
};


/**
 * 
 * Home Page video
 * Expert Tab Selection Tracking
 * Captures clicks on expert profile tabs and extracts name/institution.
 */
const initExpertTabTracking = () => {
  document.addEventListener('click', function(event) {
    // 1. Find the clicked tab button
    const tabBtn = event.target.closest('.cve-tab');
    if (!tabBtn) return;

    try {
      // 2. Extract Data from DOM
      // Name is usually in .cve-tab-name
      const expertName = tabBtn.querySelector('.cve-tab-name')?.textContent.trim() || 'Unknown Expert';
      
      // Institution is mapped to .cve-tab-sub (or fallback if empty)
      //const expertInstitution = tabBtn.querySelector('.cve-tab-sub')?.textContent.trim() || 'Not Specified';

      // 3. Construct DataLayer Payload
      const pushData = {
        event: 'expert_tab_select',
        element_text: expertName
        //expert_institution: expertInstitution
      };

      // 4. Push to DataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // 5. Verification Log
    //   console.log(
    //     `%c🎓 EXPERT SELECTED: ${expertName}`, 
    //     'background: #8e44ad; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;',
    //     pushData
    //   );

    } catch (err) {
      console.error('❌ GA4 Expert Tab Tracking Error:', err);
    }
  });
};


/**
 * Expert Video Testimonial Tracking - FIXED
 * Fix: Prevents multiple "video_start" events when clicking or resuming.
 */
const initExpertVideoTracking = () => {
  // Keep track of video elements that have already sent a 'start' event
  const startedVideos = new WeakSet();

  document.addEventListener('play', function(event) {
    const videoElement = event.target;

    // 1. Filter for specific expert videos
    if (!videoElement.classList.contains('js-cve-html5')) return;

    // 2. ONLY fire if this video hasn't triggered 'video_start' yet
    if (startedVideos.has(videoElement)) {
      //console.log('ℹ️ Video resumed - start event already sent.');
      return;
    }

    try {
      const activeTab = document.querySelector('.cve-tab.active .cve-tab-name');
      const expertName = activeTab ? activeTab.textContent.trim() : 'Unknown Expert';
      
      const pushData = {
        event: 'video_start',
        video_title: `Testimonial - ${expertName}`,
        element_location: 'expert_testimonials'
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // 3. Mark this video as "started" so it won't fire again
      startedVideos.add(videoElement);

    //   console.log(
    //     `%c▶️ VIDEO START (FIRST PLAY): ${pushData.video_title}`, 
    //     'background: #16a085; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;',
    //     pushData
    //   );

    } catch (err) {
      console.error('❌ GA4 Video Tracking Error:', err);
    }
  }, true);
};

/**
 * Expert Video Progress Tracking
 * Tracks milestones (25%, 50%, 75%) for HTML5 videos in expert panels.
 */
const initExpertVideoProgressTracking = () => {
  // Store milestones already reached in the current session to prevent duplicate hits
  const trackedMilestones = new WeakMap();

  document.addEventListener('timeupdate', function(event) {
    const video = event.target;

    // 1. Filter for expert testimonial videos only
    if (!video.classList.contains('js-cve-html5')) return;

    // Initialize tracking for this specific video element if it doesn't exist
    if (!trackedMilestones.has(video)) {
      trackedMilestones.set(video, new Set());
    }

    const milestones = trackedMilestones.get(video);
    const currentTime = video.currentTime;
    const duration = video.duration;

    if (!duration || duration === 0) return;

    const progress = Math.floor((currentTime / duration) * 100);
    const targets = [25, 50, 75];

    targets.forEach(milestone => {
      // If the video has reached the milestone and we haven't tracked it yet
      if (progress >= milestone && !milestones.has(milestone)) {
        
        try {
          // Identify expert name from the active tab
          const activeTab = document.querySelector('.cve-tab.active .cve-tab-name');
          const expertName = activeTab ? activeTab.textContent.trim() : 'Unknown Expert';
          const videoTitle = `Testimonial - ${expertName}`;

          const pushData = {
            event: 'video_progress',
            video_title: videoTitle,
            video_percent: milestone,
            element_location: 'expert_testimonials'
          };

          // DataLayer Push
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(pushData);

          // Mark as tracked
          milestones.add(milestone);

          // Verification Log
          // console.log(
          //   `%c📊 VIDEO PROGRESS: ${videoTitle} reached ${milestone}%`, 
          //   'background: #2980b9; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;',
          //   pushData
          // );
        } catch (err) {
          console.error('❌ GA4 Video Progress Error:', err);
        }
      }
    });

    // Reset milestones if the video is restarted/looped
    if (currentTime < 1 && milestones.size > 0) {
      milestones.clear();
    }
  }, true);
};


/**
 * Expert Video Completion Tracking
 * Captures 'video_complete' when the HTML5 video reaches the end.
 */
const initExpertVideoCompleteTracking = () => {
  // Use the 'ended' event listener
  document.addEventListener('ended', function(event) {
    const videoElement = event.target;

    // 1. Filter for expert testimonial videos only
    if (!videoElement.classList.contains('js-cve-html5')) return;

    try {
      // 2. Identify expert name from the active tab to match Start/Progress events
      const activeTab = document.querySelector('.cve-tab.active .cve-tab-name');
      const expertName = activeTab ? activeTab.textContent.trim() : 'Unknown Expert';
      const videoTitle = `Testimonial - ${expertName}`;

      // 3. Construct DataLayer Payload
      const pushData = {
        event: 'video_complete',
        video_title: videoTitle,
        element_location: 'expert_testimonials'
      };

      // 4. DataLayer Push
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(pushData);

      // 5. Verification Log
    //   console.log(
    //     `%c🏁 VIDEO COMPLETE: ${videoTitle}`, 
    //     'background: #27ae60; color: #fff; padding: 2px 5px; border-radius: 3px; font-weight: bold;',
    //     pushData
    //   );

    } catch (err) {
      console.error('❌ GA4 Video Complete Tracking Error:', err);
    }
  }, true); // Use capture phase
};



  // Initialize
  initContactCtaClick();
  //initOrderNowClick();
  initCartCtaTracking();
  initRoiCalculatorClick();
  initFooterCtaClicks();
  //initRemoveFromCartTracking();
  initViewItemTracking();
  initAddToCartTracking();
  initClickCtaTracking();
  initConsumableProductTracking();
  initConsumableAddToCartTracking();
  initCollectionClickTracking();
  initNewsletterSignupTracking();
  initResourceClickTracking();
  initCollectionListViewTracking();
  initSelectItemTracking();
  initSupportClickTracking();
  initLoginClickTracking();
  initMobileNavTracking();
  initLogoClickTracking();
  initNavigationTracking();
  initCurrencyTracking();
  initHeroCarouselTracking();
  initProductSpotlightTracking();
  initSerumCarouselTracking();
  initFooterLogoTracking();
  initFooterGeneralNavTracking();
  initCartEmptyTracking();
  initBackToTopTracking();
  initBeforeAfterTracking();
  initBeforeAfterSliderTracking();
  initSuccessVideoTracking();
  initSuccessVideoProgress();
  initSuccessVideoCompletion();
  initSuccessStoriesCTATracking();
  initROICalculatorTracking();
  initROICTATracking();
  initDemoFormTracking();
  initBottomCTATracking();
  initNotifyMeTracking();
  initLoginCTATracking();
  initFloatingNotifyTracking();
  initEducationTabTracking();
  initBlogResourceTracking();
  initDynamicViewAllTracking();
  initFAQContactTracking();
  initMobileFilterCTA();
  initClearAllFiltersTracking();
  initSortTracking();
  initAccordionObserver();
  initAvailabilityFilterTracking();
  initModelFilterTracking();
  initCategoryFilterTracking();
  initPriceRangeTracking();
  initSearchResultClickTracking();
  initAboutHeroClickTracking();
  initCharityCarouselTracking();
  initLeadershipCarouselTracking();
  initBlogDeviceCtaTracking();
  initRelatedArticlesTracking();
  initContactFormTracking();
  init404CtaTracking();
  initCartConflictTracking();
  initCartClearTracking();
  initSelectItemCart();
  initAddToCartQuantity();
  initRemoveFromCartTracking1();
  initCartCtaTrackingCountinue();
  initViewCartTracking();
  initArticleLinkTracking();
  //initCartSelectItemTracking();
  initCartDrawerSelectItemTracking();
  initCartBiteNotifyMeTracking();
  initCartBiteLeadTracking();
  initGlaceVideoProgressTracking();
  initGlaceVideoCompleteTracking();
  initFilterViewResultsTracking();
  initBlogListingTracking();
  initExpertTabTracking();
  initExpertVideoTracking();
  initExpertVideoProgressTracking();
  initExpertVideoCompleteTracking();

});